{
  "all-string": "Todos",
  "monday-string": "Lunes",
  "tuesday-string": "Martes",
  "wednesday-string": "Miércoles",
  "thursday-string": "Jueves",
  "friday-string": "Viernes",
  "saturday-string": "Sábado",
  "sunday-string": "Domingo",
  "reset-string": "Reiniciar",
  "select-string": "Seleccionar",
  "selectAndReopen-string": "Seleccionar y reabrir",
  "save-string": "Guardar",
  "done-string": "Listo",
  "cancel-string": "Cancelar",
  "discardChanges-string": "Descartar",
  "profileUnsavedLeaveAlertTitle-string": "DESCARTAR CAMBIOS DEL PERFIL",
  "profileUnsavedLeaveAlertText-string": "Hay cambios del perfil sin guardar. ¿Quieres descartarlos?",
  "coachSettingsUnsavedLeaveAlertTitle-string": "DESCARTAR CAMBIOS DE CONFIGURACIÓN",
  "coachSettingsUnsavedLeaveAlertText-string": "Hay cambios de configuración sin guardar. ¿Quieres descartarlos?",
  "delete-string": "Eliminar",
  "replace-string": "Remplazar",
  "modify-string": "Modificar",
  "unlink-string": "Desvincular",
  "create-string": "Crear",
  "sortBy-string": "Ordenar por",
  "okay-string": "De acuerdo",
  "weeklyView-string": "Vista Semanal",
  "workoutsView-string": "Vista de entrenamientos",
  "blockView-string": "Vista del Bloque",
  "oldView-string": "Vista anterior",
  "blockViewUpdateTitle-string": "Presentamos la nueva vista de Entrenamientos",
  "blockViewUpdateBadge-string": "Gran actualización",
  "blockViewUpdateIntro-string": "Hemos trabajado mucho en esta actualización. En la nueva vista de Entrenamientos tendrás todas las funciones de antes, además de:",
  "blockViewUpdateBullet1-string": "Reordenar series.",
  "blockViewUpdateBullet2-string": "Usar el buscador automático de ejercicios.",
  "blockViewUpdateBullet3-string": "Copiar y pegar series.",
  "blockViewUpdateBullet4-string": "Copiar y pegar ejercicios.",
  "blockViewUpdateBullet5-string": "Mover ejercicios entre sesiones de entrenamiento.",
  "blockViewUpdateButton-string": "Pruébalo",
  "blockViewTutorialTitle-string": "Aprende a usar la nueva vista de Entrenamientos",
  "blockViewTutorialCta-string": "Ver tutorial",
  "blockViewFeedbackCta-string": "Enviar feedback",
  "blockViewOldViewHint-string": "La vista antigua está disponible temporalmente, si quieres acceder a ella, haz click",
  "blockViewOldViewLink-string": "aquí",
  "blockViewRevertTitle-string": "Volver a la vista antigua de entrenamientos",
  "blockViewRevertSubtitle-string": "Cuéntanos qué no te gusta o qué falta para mejorar la vista nueva. Si quieres contactar más directamente con nosotros, escríbenos en Instagram @efortapp.",
  "blockViewRevertPlaceholder-string": "Cuéntanos qué te gustaría que mejoraramos en la nueva vista...",
  "blockViewRevertButton-string": "Volver a la vista antigua",
  "legacyPlanViewTemporaryNotice-string": "Esta vista está disponible temporalmente y se eliminará pronto.",
  "legacyBlockViewSettingsTitle-string": "Vista de entrenamientos (temporal)",
  "legacyBlockViewOptionLegacy-string": "Antigua",
  "legacyBlockViewOptionNew-string": "Nueva",
  "athleteCountOne-string": "{{count}} Atleta",
  "athleteCount-string": "{{count}} Atletas",
  "yes-string": "Sí",
  "none-string": "Ninguno",
  "vegetarian-string": "Vegetariano",
  "vegan-string": "Vegano",
  "changeName-string": "Cambiar nombre",
  "rename-string": "Renombrar",
  "back-string": "Atrás",
  "currency-string": "€",
  "confirm-string": "Confirmar",
  "edit-string": "Editar",
  "change-string": "Cambiar",
  "manage-string": "Gestionar",
  "spanish-string": "Español",
  "english-string": "Inglés",
  "accept-string": "Aceptar",
  "invite-string": "Invitar",
  "link-string": "Vincular",
  "notLink-string": "No vincular",
  "videoLink-string": "Enlace de Vídeo",
  "invalidUrl-string": "Formato de URL no válido",
  "nutritionFoodInvalidUrlDescription-string": "Actualiza la URL a un formato válido para guardar los cambios",
  "nutritionOfflineTitle-string": "Nutrición no está disponible sin conexión",
  "nutritionOfflineDescription-string": "Vuelve a conectarte para seguir trabajando en Nutrición. Los cambios pendientes de nutrición se sincronizarán cuando regrese la conexión.",
  "nutritionOfflineGoToDashboard-string": "Ir a inicio",
  "help-string": "Ayuda",
  "copy-string": "Copiar",
  "paste-string": "Pegar",
  "deleteFood-string": "Eliminar alimento",
  "deleteEquivalent-string": "Eliminar equivalencia",
  "close-string": "Cerrar",
  "enable-string": "Habilitar",
  "viewTutorial-string": "Ver tutorial",
  "optional-string": "(Opcional)",
  "pressEnterToSelectFirstResult-string": "Pulsa Enter para seleccionar el primer resultado",
  "enterSelectsFirstHint-string": "↵ Enter selecciona el primero",
  "horizontalScrollHint-string": "Usa ⇧ + la rueda para desplazarte horizontalmente",
  "onboardingNameTitle-string": "Hola, ¿cómo deberíamos llamarte?",
  "onboardingNameSubtitle-string": "Este es el nombre que veréis tú y tus atletas",
  "onboardingNamePlaceholder-string": "Nombre",
  "onboardingAthletesCountTitle-string": "¿Cuántos atletas tienes actualmente?",
  "onboardingAthletesCount1-5-string": "1 - 5 atletas",
  "onboardingAthletesCount6-15-string": "6 - 15 atletas",
  "onboardingAthletesCount16-30-string": "16 - 30 atletas",
  "onboardingAthletesCount31-50-string": "31 - 50 atletas",
  "onboardingAthletesCount50plus-string": "Más de 50 atletas",
  "onboardingAthleteTypeTitle-string": "¿Qué tipo de atletas llevas?",
  "onboardingAthleteTypeSubtitle-string": "Esto ayuda a personalizar tu experiencia",
  "onboardingAthleteTypePowerlifters-string": "Powerlifters",
  "onboardingAthleteTypeBodybuilders-string": "Bodybuilders",
  "onboardingAthleteTypeOther-string": "Otros",
  "onboardingFeaturesTitle-string": "¿Para qué quieres usar Efort Coach?",
  "onboardingFeaturesSubtitle-string": "Siempre puedes añadir funcionalidades más adelante",
  "onboardingFeaturePrograms-string": "Crear bloques de entrenamiento",
  "onboardingFeatureVideos-string": "Recibir vídeos y comunicarme con mis atletas",
  "onboardingFeatureCompetitions-string": "Planificar competiciones de powerlifting",
  "onboardingFeatureBilling-string": "Hacer seguimiento de los pagos de mis atletas",
  "onboardingFeatureApplications-string": "Gestionar nuevas solicitudes de atletas",
  "onboardingFeatureForms-string": "Automatizar formularios",
  "onboardingLogoTitle-string": "Añade tu logo",
  "onboardingLogoSubtitle-string": "Personaliza la app con tu marca",
  "onboardingLogoPlaceholder-string": "LOGO",
  "onboardingLogoUploading-string": "Subiendo...",
  "onboardingLogoChangeFile-string": "Cambiar archivo",
  "onboardingLogoChooseFile-string": "Elegir archivo",
  "onboardingLogoDragDrop-string": "o arrastra y suelta tu imagen aquí",
  "onboardingLogoErrorInvalidType-string": "Por favor, selecciona un archivo de imagen válido (JPEG, PNG, GIF o WebP)",
  "onboardingLogoErrorFileSize-string": "El tamaño de la imagen debe ser inferior a 5MB",
  "onboardingLogoErrorReadFile-string": "Error al leer el archivo seleccionado",
  "onboardingLogoErrorProcessing-string": "Ha ocurrido un error al procesar la imagen",
  "onboardingLogoSkip-string": "Omitir",
  "onboardingPreferencesTitle-string": "Elige tus preferencias",
  "onboardingPreferencesSubtitle-string": "Siempre puedes cambiarlas más adelante",
  "onboardingPreferenceMeasurementUnit-string": "Unidad de medida",
  "onboardingPreferenceIntensityRating-string": "Medida de intensidad",
  "openAthlete-string": "Abrir atleta",
  "expandChat-string": "Expandir chat",
  "minimizeChat-string": "Minimizar chat",
  "showChat-string": "Mostrar chat",
  "hideChat-string": "Ocultar chat",
  "onboardingPreferenceIntensityRatingTooltip-string": "Selecciona la opción para prescribir las intensidades de carga como Tasa de Esfuerzo Percibido (RPE) o Repeticiones en Reserva (RIR)",
  "onboardingPreferenceShowExerciseStats-string": "Mostrar estadísticas de ejercicio a los atletas",
  "onboardingPreferenceShowExerciseStatsTooltip-string": "Selecciona si quieres que los atletas vean sus estadísticas de ejercicio (e1RM, tonelaje, etc.) mientras entrenan.",
  "onboardingPreferenceShowPriority-string": "Mostrar prioridad de series a ti y a tus atletas",
  "onboardingPreferenceShowPriorityTooltip-string": "Selecciona si quieres mostrar la prioridad de cada serie (alta, media, baja) al pautar entrenamientos.",
  "onboardingPreferenceKg-string": "kg",
  "onboardingPreferenceLbs-string": "lbs",
  "onboardingPreferenceRPE-string": "RPE",
  "onboardingPreferenceRIR-string": "RIR",
  "onboardingPreferenceShow-string": "mostrar",
  "onboardingPreferenceHide-string": "ocultar",
  "onboardingBuildApp-string": "Crea tu app",
  "optionalFeature-string": "Funcionalidad opcional",
  "planWeeklyProgressionMainLifts-string": "Planifica la progresión semanal de los ejercicios básicos",
  "blocksWorkWithoutFeature-string": "Puedes crear bloques sin esta funcionalidad. Habilítala solo si quieres herramientas avanzadas de programación de powerlifting.",
  "blockOverview-string": "Resumen del bloque",
  "blockOverviewAvailableText-string": "El resumen del bloque está disponible cuando habilitas la funcionalidad de programación opcional en el panel del bloque.",
  "offlineAlertTitle-string": "ESTÁS SIN CONEXION A INTERNET",
  "offlineAlertText-string": "Para trabajar con un atleta, debes descargar su planificación antes de quedarte sin conexión",
  "offlineFormsInformationMissing-string": "Algunos formularios pueden no aparecer en modo offline.",
  "offlineBlocksInformationMissing-string": "Algunos bloques pueden no aparecer en modo offline.",
  "offlineCompetitionsInformationMissing-string": "Algunas competiciones pueden no aparecer en modo offline.",
  "deletePredefinedExerciseAlertTitle-string": "ELIMINAR EJERCICIO PREDEFINIDO",
  "deletePredefinedExerciseAlertText-string": "¿Estás seguro/a de eliminar el ejercicio predefinido?",
  "deletePredefinedAttributeAlertTitle-string": "ELIMINAR MODIFICADOR PREDEFINIDO",
  "deletePredefinedAttributeAlertText-string": "¿Estás seguro/a de eliminar el modificador predefinido?",
  "sureToDelete-string": "¿Estás seguro/a de eliminar '{{itemName}}'?",
  "automaticProtocolsAlertTitle-string": "REEMPLAZAR SERIES DEL EJERCICIO",
  "automaticProtocolsAlertText-string": "Este ejercicio ya tiene series rellenadas. ¿Quieres reemplazar las series de la semana 1 con las del protocolo?",
  "noProtocolExerciseAlertTitle-string": "PRIMERO SELECCIONA UN EJERCICIO",
  "noProtocolExerciseAlertText-string": "Debes elegir qué ejercicio asignar a este slot antes de establecer su protocolo.",
  "emptyProtocolsTitle-string": "Sin Protocolos Definidos",
  "emptyProtocolsText-string": "Agrega protocolos para habilitar el resumen de este bloque",
  "protocolSyntaxTitle-string": "PROTOCOLOS AUTOMÁTICOS",
  "protocolSyntaxText-string": "Aquí tienes ejemplos de los distintos tipos de protocolo en los que las series se crearán automáticamente en el ejercicio:\n\n'Ramp 3x4 @7'\n\n'3x4 @5'\n\n'Single @5'\n\n'x4 @5'\n\n'x4 @4-5-6'\n\n'175-180-185 x4'\n\n'3x5x200'",
  "protocolDetectionTitle-string": "NO SE HA DETECTADO NINGÚN PROTOCOLO AUTOMÁTICO",
  "protocolDetectionText-string": "Aquí tienes ejemplos de los distintos tipos de protocolo en los que las series se crearán automáticamente en el ejercicio:\n\n'Ramp 3x4 @7'\n\n'3x4 @5'\n\n'Single @5'\n\n'x4 @5'\n\n'x4 @4-5-6'\n\n'175-180-185 x4'\n\n'3x5x200'",
  "actualWithDataProtocolWarningTitle-string": "LAS SERIES YA CONTIENEN DATOS",
  "actualWithDataProtocolWarningText-string": "Cambiar el protocolo regenerará las series y sobrescribirá los datos existentes. ¿Seguro que quieres modificar el protocolo para este ejercicio?",
  "actualWithDataCopyProtocolWarningTitle-string": "LAS SERIES YA CONTIENEN DATOS",
  "actualWithDataCopyProtocolWarningText-string": "Copiar este slot reemplazará el ejercicio de la semana {{week}}, incluidos sus modificadores y series. ¿Seguro que quieres sobrescribir los datos existentes?",
  "actualWithDataCopyWeekProtocolsWarningTitle-string": "LAS SERIES YA CONTIENEN DATOS",
  "actualWithDataCopyWeekProtocolsWarningText-string": "Copiar esta semana reemplazará todos los ejercicios de la semana {{week}}, incluidos sus modificadores y series. ¿Seguro que quieres sobrescribir los datos existentes?",
  "pasteSetsConfirmationTitle-string": "REEMPLAZAR SERIES",
  "pasteSetsConfirmationMessage-string": "Las series ya tienen datos, ¿seguro que quieres reemplazar las series?",
  "search-string": "Buscar",
  "dashboard-string": "Panel",
  "TITOL INDEX/LOGIN": "",
  "welcome-string": "Bienvenido",
  "termsAndConditions-string": "Términos y condiciones",
  "privacyPolicy-string": "Política de privacidad",
  "welcomeToEfortCoach-string": "Bienvenido a Efort Coach",
  "theAppForCoaches-string": "La aplicación para entrenadores de powerlifting",
  "yourEmail-string": "Tu correo electrónico",
  "yourPassword-string": "Tu contraseña",
  "signUp-string": "Regístrate",
  "signIn-string": "Inicia sesión",
  "alreadyHaveAccount-string": "¿Ya tienes cuenta?",
  "tryEfortCoachFree-string": "Prueba Efort Coach gratis durante 10 días",
  "noCreditCardNeeded-string": "Sin tarjeta de crédito. Uso ilimitado. Sin compromiso.",
  "byContinuingYouAgree-string": "Al continuar, aceptas los",
  "and-string": "y la",
  "replaceSpreadsheets-string": "Reemplaza cientos de excels con Efort Coach",
  "trustedByCoaches-string": "Respaldada por entrenadores con experiencia",
  "password-string": "Contraseña",
  "passwordMinLength-string": "La contraseña debe tener al menos 6 caracteres",
  "emailRequired-string": "El correo electrónico es obligatorio",
  "forgotPassword-string": "¿Has olvidado tu contraseña?",
  "passwordResetEmailSent-string": "¡Correo de recuperación enviado! Revisa tu bandeja de entrada.",
  "resetYourPassword-string": "Restablece tu contraseña",
  "resetPasswordDescription-string": "Introduce el correo electrónico asociado con tu cuenta y te enviaremos un enlace para restablecer tu contraseña.",
  "continue-string": "Continuar",
  "returnToSignIn-string": "Volver al inicio de sesión",
  "checkYourInbox-string": "Revisa tu bandeja de entrada",
  "checkInboxDescription-string": "¡Gracias! Si {email} coincide con una dirección de correo electrónico que tenemos registrada, te hemos enviado un correo con más instrucciones para restablecer tu contraseña.\n\nSi no has recibido un correo en 5 minutos, revisa tu spam, reenvía o prueba con otra dirección de correo electrónico.",
  "resend-string": "Reenviar",
  "welcomeBack-string": "Bienvenido de nuevo",
  "signInToYourAccount-string": "Inicia sesión en tu cuenta",
  "newToEfortCoach-string": "¿Nuevo en Efort Coach?",
  "userNotFound-string": "Usuario no encontrado",
  "wrongPassword-string": "Contraseña incorrecta",
  "invalidCredentials-string": "Correo electrónico o contraseña inválidos",
  "emailAlreadyUser-string": "El email ya está en uso. Inicia sesión con tu contraseña o con Google en un navegador compatible (Chrome, Safari o Edge).",
  "passwordNotLongEnough-string": "La contraseña debe tener almenos 6 carácteres.",
  "invalidEmail-string": "Correo electrónico inválido. Comprueba que no haya errores.",
  "allRightsReserved-string": "© 2026 Efort Systems S.L.\nTodos los derechos reservados.",
  "welcomeToEfortCoachExclamation-string": "¡Bienvenido a Efort Coach!",
  "startYourFreeTrial-string": "Empieza tu prueba gratuita de 10 días",
  "whatsIncluded-string": "¿Qué incluye Efort Coach?",
  "bulletText1-string": "Acceso a todas las herramientas de coaching",
  "bulletText2-string": "Gestión centralizada de atletas.",
  "bulletText3-string": "Tus atletas reciben sus planes en Efort.",
  "bulletText4-string": "Almacenamiento ilimitado de vídeos.",
  "bulletText5-string": "Acceso a la aplicación móvil de entrenador.",
  "yourFullName-string": "Tu nombre completo",
  "iHaveRead-string": "He leído y acepto los",
  "lowercasedTermsAndConditions-string": "términos y condiciones",
  "haveToAcceptTerms-string": "Debes aceptar los términos y condiciones",
  "getStarted-string": "Empezar",
  "incompatibleNavigator-string": "¡Oops! Este navegador no es compatible. Por favor, accede con otro navegador (Google Chrome, Safari...)",
  "resetAthletesAlertTitle-string": "REINICIAR ATLETAS COMPLETADOS",
  "resetAthletesAlertText-string": "¿Estás seguro/a de reiniciar los atletas completados?",
  "TITOL TUTORIAL STEPS": "",
  "tutorials-string": "Tutoriales",
  "viewTutorials-string": "Ver tutoriales",
  "learnToUseEfortCoach-string": "Aprende a usar Efort Coach",
  "upgradePlan-string": "Mejora tu plan",
  "completedTutorialSteps-string": "{{completedSteps}} / 4 Completados",
  "gettingStarted-string": "Primeros Pasos",
  "learnEfortTutorial-string": "{{coachName}}, sigue estos pasos para empezar.",
  "tutorialStep1-string": "Crea tu cuenta",
  "tutorialStep1text1-string": "Crea tu cuenta de Efort Coach.",
  "tutorialStep2-string": "Mira la app de tus atletas",
  "tutorialStep2text1-string": "Descubre lo que tus atletas experimentarán con Efort.",
  "tutorialStep2text2-string": "Ver la app de atleta",
  "tutorialStep3-string": "Crea tu primer entrenamiento",
  "tutorialStep3text1-string": "Añade tu primer ejercicio a un entrenamiento.",
  "tutorialStep3text2-string": "Crear entrenamiento",
  "tutorialStep4-string": "Invita a tus atletas",
  "tutorialStep4text1-string": "Mira lo fácil que es invitar a tus atletas a la app.",
  "tutorialStep4text2-string": "Invita a atletas",
  "athleteAppOnboardingTitle-string": "Esto es lo que verán tus atletas",
  "athleteAppPreviewTitle-string": "Vista previa de la app de atleta",
  "athleteAppOnboarding1-string": "Para probar la app tú mismo, descarga Efort en tu móvil (",
  "athleteAppOnboarding2-string": "Google Play & App Store) e inicia sesión con tu cuenta:",
  "athleteAppOnboarding-markCompleted": "Marcar como completado",
  "athleteAppOnboardingHome-string": "Inicio",
  "athleteAppOnboardingExercise-string": "Ejercicio",
  "athleteAppOnboardingWorkouts-string": "Entrenamientos",
  "athleteAppOnboardingChat-string": "Chat",
  "athleteAppOnboardingCalendar-string": "Calendario",
  "athleteAppOnboardingCompetitions-string": "Competiciones",
  "athleteAppOnboardingStatistics-string": "Estadísticas",
  "athleteAppOnboardingBlocks-string": "Bloques",
  "athleteAppOnboardingExercises-string": "Ejercicios",
  "bookCall-string": "Agenda una llamada",
  "feedbackText-string": "Hola {{coachName}}, gracias por usar Efort Coach. Compártenos si hay alguna funcionalidad que te gustaría ver.",
  "blockViewFeedbackTitle-string": "Feedback de la nueva vista de Entrenamientos",
  "blockViewFeedbackText-string": "{{coachName}}, cuéntanos qué te parece la nueva vista y cómo podemos mejorarla.",
  "blockViewFeedbackPlaceholder-string": "Tu feedback",
  "sendFeedback-string": "ENVIAR FEEDBACK",
  "sendFeedbackPlaceholder-string": "Tu feedback",
  "feedbackThanksTitle-string": "Gracias por compartir tu feedback",
  "feedbackThanksDescription-string": "Lo revisaremos y lo tendremos en cuenta para seguir mejorando Efort Coach.",
  "cookiePanelText-string": "Efort Coach usa cookies. Ver",
  "cookiePanelLink-string": "Aviso de Cookies",
  "cookiePanelTextEnd-string": "para más detalles.",
  "cookiePanelReject-string": "Rechazar",
  "cookiePanelAccept-string": "Aceptar",
  "tutorialCompetitionGameplan-string": "Aprende a crear competiciones y a preparar game plans para tus atletas.",
  "tutorialLibraryForms-string": "Aprende a configurar cuestionarios semanales y de fin de bloque que se envían automáticamente a tus atletas.",
  "tutorialLibraryWorkouts-string": "Aprende a usar la librería de entrenamientos.",
  "tutorialBilling-string": "Aprende a usar la facturación para registrar y seguir los pagos de tus atletas.",
  "tutorialProgramDashboard-string": "En la vista de Panel, planifica la progresión de los básicos a lo largo del bloque. Aprende a crear un bloque completo.",
  "tutorialProgramWorkouts-string": "En la vista de Entrenamientos, crea y edita las sesiones que tus atletas verán desde su app. Aprende cómo hacerlo.",
  "tutorialCalendarMacrocycle-string": "Programa la progresión de los básicos a lo largo de varios bloques. Aprende cómo hacerlo.",
  "TITOL WHATS NEW": "",
  "whatsNew-string": "Novedades",
  "viewWhatsNew-string": "Ver novedades",
  "productUpdatesForEfortCoach-string": "Actualizaciones de Efort Coach",
  "currentVersion-string": "Versión actual: {{version}}",
  "olderUpdates-string": "…hubo más actualizaciones anteriormente",
  "wantToRequestFeature-string": "¿Quieres solicitar una funcionalidad o comentar estas actualizaciones?",
  "sendUsYourIdeas-string": "Comparte tus ideas para saber qué desarrollar a continuación. Leemos todos los mensajes.",
  "gotIt-string": "Entendido",
  "accessTutorials-string": "Acceder a los tutoriales →",
  "sendFeedbackLowercased-string": "Enviar feedback",
  "v200WorkoutsViewRedesign-string": "Rediseño completo de la vista de Entrenamientos en Planificación",
  "v200WorkoutsViewRedesignIntro-string": "Hemos rediseñado por completo la vista de Entrenamientos en Planificación para que sea mucho más fácil de navegar. Ahora puedes:",
  "v200WorkoutsViewRedesignBullet1-string": "Reordenar series.",
  "v200WorkoutsViewRedesignBullet2-string": "Usar el buscador automático de ejercicios.",
  "v200WorkoutsViewRedesignBullet3-string": "Copiar y pegar series.",
  "v200WorkoutsViewRedesignBullet4-string": "Copiar y pegar ejercicios.",
  "v200WorkoutsViewRedesignBullet5-string": "Mover ejercicios entre sesiones de entrenamiento.",
  "v201BlockExportAllWeeks-string": "Exportar todas las semanas del bloque",
  "v201BlockExportAllWeeksDesc-string": "Cuando exportas un bloque a la librería de bloques, ahora se exportan todas las semanas del bloque por defecto.",
  "v201MasterCategoryWRPF-string": "Categoría Master y federación WRPF en Competiciones",
  "v201MasterCategoryWRPFDesc-string": "Hemos añadido la categoría Master y la federación WRPF a Competiciones.",
  "v202ImprovedVideoQuality-string": "Mejor calidad de vídeo",
  "v202ImprovedVideoQualityDesc-string": "Hemos mejorado la resolución de los vídeos enviados por los atletas a través del chat.",
  "v202EmojisInChat-string": "Emojis en el chat",
  "v202EmojisInChatDesc-string": "Ahora puedes enviar emojis a tus atletas en el chat.",
  "v202RemovedCompetitorStatus-string": "Eliminado el estado de competidor del atleta",
  "v202RemovedCompetitorStatusDesc-string": "Hemos eliminado el estado de competidor de los atletas. Ahora puedes añadir cualquier atleta a una competición de powerlifting.",
  "v203BlocksListRedesign-string": "Rediseño de la lista de bloques",
  "v203BlocksListRedesignDesc-string": "Hemos rediseñado la lista de bloques. Ahora los bloques se organizan en carpetas y puedes ver qué bloques se han completado y cuáles no. También puedes arrastrar bloques entre carpetas para mantenerlos organizados.",
  "v203WorkoutLibraryUpdated-string": "Mejoras en la librería de entrenamientos",
  "v203WorkoutLibraryUpdatedDesc-string": "Hemos actualizado la librería de entrenamientos para que crear entrenamientos sea más rápido.",
  "v203ReorderLibrary-string": "Reordenar entrenamientos y bloques en tu librería",
  "v203ReorderLibraryDesc-string": "Ahora puedes reordenar entrenamientos y bloques desde tus librerías de entrenamientos y bloques.",
  "v203SettingsProfileVisual-string": "Pequeños cambios visuales en Ajustes y Perfil del atleta",
  "v203SettingsProfileVisualDesc-string": "Pequeños ajustes visuales en Ajustes y la vista del Perfil del atleta para que se vea más clara.",
  "v204InvitationsInHomeCharts-string": "Trabaja con atletas mientras aceptan tu invitación",
  "v204InvitationsInHomeChartsDesc-string": "Para nuevas invitaciones, ahora puedes empezar a crear bloques para un atleta mientras acepta tu invitación. Al aceptar, recibirá automáticamente su planificación en la app. Las nuevas invitaciones de atletas ahora también se tienen en cuenta en los gráficos de la vista de Inicio.",
  "v204OfflineModeImprovements-string": "Mejoras en el modo sin conexión",
  "v204OfflineModeImprovementsDesc-string": "Ahora puedes trabajar con tantos atletas como quieras sin conexión, siempre que hayas descargado sus planes previamente estando en línea.",
  "v129ExerciseSearchbar-string": "Nuevo buscador de ejercicios en el Panel",
  "v129ExerciseSearchbarDesc-string": "Desde el Panel, ahora puedes escribir el nombre de un ejercicio y el buscador detectará automáticamente el ejercicio principal y los modificadores. También tendrás acceso rápido a los ejercicios usados recientemente por atleta.",
  "v129StatisticsImprovements-string": "Mejoras en estadísticas",
  "v129StatisticsImprovementsDesc-string": "Ahora puedes seleccionar los slots que quieres analizar. Al seleccionar un bloque, aparecerán sugerencias de ejercicios automáticamente para que las estadísticas sean más accesibles y fáciles de usar. También hemos mejorado la interfaz para que sea más clara.",
  "v129ApplicationsIndicator-string": "Indicador de nuevas inscripciones",
  "v129ApplicationsIndicatorDesc-string": "Cuando recibas una nueva inscripción, al abrir Efort Coach verás un punto junto a Inscripciones en la barra lateral para indicarte que hay una nueva solicitud por revisar.",
  "v130SmallProgramImprovements-string": "Pequeñas mejoras en Planificación",
  "v130SmallProgramImprovementsDesc-string": "Hemos realizado pequeñas mejoras en algunas vistas (añadir enlaces de ejercicios, vincular ejercicios a slots...). También hemos hecho mejoras internas para preparar una gran actualización que llegará pronto.",
  "v130ChatMessageTimeFix-string": "Corrección de las horas de los mensajes en el chat",
  "v130ChatMessageTimeFixDesc-string": "Hemos corregido un problema por el que las horas de los mensajes en el chat a veces se mostraban incorrectamente. Las horas ahora son precisas y fiables.",
  "v128SimplifiedModifiers-string": "Categorías de modificadores y ejercicios simplificadas",
  "v128SimplifiedModifiersDesc-string": "Hemos eliminado la categoría de ejercicios de halterofilia y los subtipos de modificadores para que las categorías sean más fáciles de entender y usar.",
  "v128ModifiersLibrary-string": "Nueva librería de modificadores",
  "v128ModifiersLibraryDesc-string": "Hemos añadido la librería de modificadores, donde puedes ver todos los modificadores, crear nuevos y reordenarlos.",
  "v128ProgramImprovements-string": "Pequeñas mejoras visuales en Planificación",
  "v128ProgramImprovementsDesc-string": "Hemos realizado pequeños ajustes visuales en la sección de Planificación.",
  "v127OpenAthleteFromChat-string": "Abrir atletas directamente desde el chat",
  "v127OpenAthleteFromChatDesc-string": "Ahora puedes abrir el perfil de un atleta directamente desde el chat haciendo clic en el botón de acceso que aparece junto a su nombre.",
  "v127OpenBlockFromCalendar-string": "Abrir bloques desde el calendario",
  "v127OpenBlockFromCalendarDesc-string": "Desde el calendario ahora puedes abrir un bloque en la sección de Planificación haciendo clic en el botón de acceso que aparece junto al nombre del bloque.",
  "v127SmallUIImprovements-string": "Mejoras en la interfaz",
  "v127SmallUIImprovementsDesc-string": "Hemos añadido pequeños mensajes de ayuda al pasar el ratón por algunos iconos, desactivado botones cuando una acción no está disponible y mejorado partes del apartado de planificación para que sea más fácil ver cuál es el siguiente paso al crear un bloque desde el panel.",
  "v126AthleteOverviewRedesign-string": "Rediseño del resumen del atleta",
  "v126AthleteOverviewRedesignDesc-string": "Hemos rediseñado por completo el resumen del atleta para que sea más fácil entender la situación de cada atleta. De un vistazo puedes ver el estado de su bloque actual, las semanas hasta su próxima competición, los entrenamientos semanales, mensajes y vídeos sin leer, el peso corporal medio, las tendencias de trac, los cuestionarios y añadir notas privadas que solo tú verás, todo organizado por semanas con un selector semanal.",
  "v126FormsNotifications-string": "Indicador de cuestionarios con cambios",
  "v126FormsNotificationsDesc-string": "Cuando un atleta envía un cuestionario, verás un punto junto a la pestaña Cuestionarios y un aviso en el resumen del atleta para identificar rápidamente los cuestionarios con respuestas nuevas que revisar.",
  "v126ActiveBlockAndWeeks-string": "Mejora en la detección de bloque y semana",
  "v126ActiveBlockAndWeeksDesc-string": "Hemos mejorado cómo se detectan el bloque y la semana actuales para que reflejen la realidad del entrenamiento del atleta. La semana que se muestra en la barra lateral siempre indica en qué semana del bloque está realmente el atleta, incluso si todavía no hay entrenamientos creados. Cuando una semana no tiene entrenamientos, su número aparece en rojo para que sepas que tienes que añadirlos.",
  "v125UpdatedDashboardDesign-string": "Pequeñas mejoras en la vista de inicio",
  "v125UpdatedDashboardDesignDesc-string": "Hemos hecho pequeñas mejoras visuales a la vista de inicio.",
  "v125InviteMultipleAthletes-string": "Invitar a varios atletas a la vez",
  "v125InviteMultipleAthletesDesc-string": "Ahora puedes invitar a varios atletas de una sola vez y hemos actualizado la guía para atletas, que puedes descargar desde la vista de Invitar Atletas o desde aquí.",
  "v125DownloadAthleteGuideIntro-string": "Descargar guía para atletas:",
  "v125DownloadAthleteGuide-string": "Descargar guía para atletas",
  "v125DefaultBlockView-string": "Vista predeterminada de bloque",
  "v125DefaultBlockViewDesc-string": "Hemos añadido el ajuste \"Vista predeterminada de bloque\", que te permite elegir si al abrir un bloque se muestra primero la vista de Entrenamientos o la vista de Panel.",
  "v124NewOptionsInSettings-string": "Nuevas opciones en Ajustes",
  "v124NewOptionsIntro-string": "Hemos añadido dos nuevas opciones en Ajustes:",
  "v124ShowExerciseStats-string": "Mostrar estadísticas de ejercicio a los atletas: ahora puedes mostrar u ocultar las estadísticas de ejercicio. Cuando están ocultas, los atletas ya no verán estadísticas como e1RM, tonelaje, etc. mientras entrenan.",
  "v124ShowSetPriority-string": "Mostrar prioridad de las series: la prioridad de las series ahora es opcional. Si la desactivas, ni tú ni tus atletas veréis la prioridad de las series.",
  "v124ToastNotification-string": "Nuevas notificaciones en la app",
  "v124ToastNotificationDesc-string": "Ahora aparecen pequeños mensajes en pantalla que confirman acciones importantes y muestran errores para que siempre sepas qué ha pasado.",
  "v124PersonalizedOnboarding-string": "Onboarding personalizado para nuevos entrenadores",
  "v124PersonalizedOnboardingDesc-string": "Los nuevos entrenadores ahora pasan por un flujo de onboarding breve en el que se les hacen algunas preguntas. Según sus respuestas, la aplicación se preconfigura para adaptarse mejor a su forma de trabajar.",
  "v124CustomizableSidebar-string": "Barra lateral personalizable",
  "v124CustomizableSidebarDesc-string": "Ahora puedes configurar la barra lateral para que se adapte a tu forma de trabajar: elige qué secciones de la app se muestran y reordénalas para que lo que más usas esté siempre arriba. Para personalizarla, pasa el ratón por la barra lateral y haz clic en el texto 'Configurar barra lateral'.",
  "v124UpdatedLoginSignup-string": "Nuevo diseño de inicio de sesión y registro",
  "v124UpdatedLoginSignupDesc-string": "Hemos renovado las pantallas de inicio de sesión y registro con un diseño más limpio y textos más claros, facilitando el inicio para nuevos entrenadores desde cualquier dispositivo.",
  "v123CoachAppStores-string": "App de entrenador en App Store y Play Store",
  "v123CoachAppStoresDesc1-string": "La app de entrenador ya está disponible tanto en ",
  "v123CoachAppStoresAppStore-string": "App Store",
  "v123CoachAppStoresDesc2-string": " como en ",
  "v123CoachAppStoresGooglePlay-string": "Google Play",
  "v123CoachAppStoresDesc3-string": ". Desde la app puedes enviar mensajes a tus atletas, revisar levantamientos, ajustar sus planificaciones y hacer seguimiento de su progreso directamente desde tu móvil.",
  "v122NewTutorialsSite-string": "Nueva web de tutoriales",
  "v122NewTutorialsSiteDesc-string": "Hemos lanzado una web de tutoriales con vídeos cortos que muestran cómo usar las partes principales de la app: Planificación, Calendario, Librería, Facturación y Competiciones. Puedes acceder en cualquier momento desde el apartado de Ajustes.",
  "v121MarkChatsUnread-string": "Marcar chats como no leídos",
  "v121MarkChatsUnreadDesc-string": "En cualquier chat, ahora puedes abrir el menú de opciones y elegir \"Marcar como no leído\". Ese chat se resaltará de nuevo para que recuerdes volver a él más tarde.",
  "v121NewVideoPlayer-string": "Nuevo reproductor de vídeo en el chat",
  "v121NewVideoPlayerDesc-string": "Hemos reemplazado el reproductor de vídeo dentro del chat por una nueva versión para mejorar la fiabilidad de reproducción y corregir errores que afectaban la revisión de vídeos en versiones anteriores.",
  "v120ExerciseLibrary-string": "Librería de ejercicios con vídeos personalizados",
  "v120ExerciseLibraryDesc-string": "El apartado de Librería ahora incluye una vista de Ejercicios. Desde ahí puedes reordenar, crear y eliminar ejercicios, y adjuntar tus propios enlaces de vídeo a cada ejercicio para que estén siempre disponibles al añadirlos al bloque de un atleta.",
  "v119NewCalendar-string": "Nuevo calendario con carpetas",
  "v119NewCalendarDesc-string": "Hemos rediseñado el Calendario. Ahora puedes crear carpetas directamente desde la vista del calendario y duplicar bloques existentes simplemente arrastrándolos.",
  "v118NewDashboard-string": "Nueva vista de Panel para planificar bloques",
  "v118NewDashboardDesc-string": "Dentro del apartado de Planificación, hay una nueva pestaña de Panel que te permite editar la información básica del bloque, definir la progresión de los ejercicios básicos a lo largo de las semanas y ajustar el split semanal.",
  "v118SetIntervals-string": "Intervalos de series",
  "v118SetIntervalsDesc-string": "Los campos de objetivo de la serie (Peso, Repeticiones y RPE/RIR) ahora admiten intervalos y textos cortos. Por ejemplo, puedes usar rangos como '10-12', 'max 220', 'min 210' o formatos cortos similares en lugar de un valor fijo.",
  "v117ChatAndVideos-string": "Chat y vídeos",
  "v117ChatAndVideosDesc-string": "Los atletas ahora pueden adjuntar vídeos directamente a series específicas. Cuando lo hacen, la app publica automáticamente un mensaje en el chat con el vídeo de esa serie, para que puedas revisarlo y enviar tu feedback directamente en el chat.",
  "tagGeneral-string": "General",
  "tagCoachApp-string": "App de entrenador",
  "tagAthleteApp-string": "App de atleta",
  "tagChat-string": "Chat",
  "tagSettings-string": "Ajustes",
  "tagForms-string": "Formularios",
  "tagApplications-string": "Inscripciones",
  "tagStatistics-string": "Estadísticas",
  "tagCompetitions-string": "Competiciones",
  "tagProgram-string": "Planificación",
  "tagModifiersLibrary-string": "Librería de modificadores",
  "tagCalendar-string": "Calendario",
  "tagAthleteOverview-string": "Resumen del atleta",
  "tagAthleteProfile-string": "Perfil del atleta",
  "tagWorkoutLibrary-string": "Librería de entrenamientos",
  "tagExerciseLibrary-string": "Librería de ejercicios",
  "tagBlock-string": "Bloque",
  "tagBlockLibrary-string": "Librería de bloques",
  "monthJan-string": "Ene",
  "monthFeb-string": "Feb",
  "monthMar-string": "Mar",
  "monthApr-string": "Abr",
  "monthMay-string": "May",
  "monthJun-string": "Jun",
  "monthJul-string": "Jul",
  "monthAug-string": "Ago",
  "monthSep-string": "Sep",
  "monthOct-string": "Oct",
  "monthNov-string": "Nov",
  "monthDec-string": "Dic",
  "TITOL NOTIFICACIONS TOAST": "",
  "clientSyncErrorTransaction-string": "Error al subir datos del atleta",
  "clientSyncErrorTransactionDescription-string": "No hemos podido subir los cambios de {{clientEmail}}. Haz clic en el icono ! para intentarlo de nuevo. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorBlocks-string": "Error al cargar bloques",
  "clientSyncErrorBlocksDescription-string": "No hemos podido cargar los bloques de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorCompetition-string": "Error al cargar competición",
  "clientSyncErrorCompetitionDescription-string": "No hemos podido cargar los datos de la competición de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorForms-string": "Error al cargar formularios",
  "clientSyncErrorFormsDescription-string": "No hemos podido cargar los formularios de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorChat-string": "Error al cargar el chat",
  "clientSyncErrorChatDescription-string": "No hemos podido cargar el chat de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorArrays-string": "Error al cargar datos del atleta",
  "clientSyncErrorArraysDescription-string": "No hemos podido cargar las notas, pesos corporales y tracs del atleta {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncErrorNutritionPlans-string": "Error al cargar planes de nutrición",
  "clientSyncErrorNutritionPlansDescription-string": "No hemos podido cargar los planes de nutrición de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "clientSyncError-string": "Error de sincronización",
  "clientSyncErrorGenericDescription-string": "No hemos podido sincronizar los datos de {{clientEmail}}. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorTransaction-string": "Error al subir datos del entrenador",
  "syncErrorTransactionDescription-string": "No hemos podido subir tus datos. Haz clic en el icono ! para intentarlo de nuevo. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorClients-string": "Error al cargar atletas",
  "syncErrorClientsDescription-string": "No hemos podido cargar a tus atletas. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorInvitations-string": "Error al cargar invitaciones",
  "syncErrorInvitationsDescription-string": "No hemos podido cargar tus invitaciones. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorChats-string": "Error al cargar chats",
  "syncErrorChatsDescription-string": "No hemos podido cargar tus chats. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorCoachData-string": "Error al cargar datos del entrenador",
  "syncErrorCoachDataDescription-string": "No hemos podido cargar tu perfil. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorCoachProfile-string": "Error al cargar los ajustes",
  "syncErrorCoachProfileDescription-string": "No hemos podido cargar tus ajustes. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorForms-string": "Error al cargar formularios",
  "syncErrorFormsDescription-string": "No hemos podido cargar tus formularios. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorCompetitions-string": "Error al cargar competiciones",
  "syncErrorCompetitionsDescription-string": "No hemos podido cargar tus competiciones. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorBlockLibrary-string": "Error al cargar la librería de bloques",
  "syncErrorBlockLibraryDescription-string": "No hemos podido cargar tu librería de bloques. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorPendingWorkspaceData-string": "Error al cargar datos de atletas invitados",
  "syncErrorPendingWorkspaceDataDescription-string": "No hemos podido cargar los datos de atletas invitados. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorPendingWorkspaceBlocks-string": "Error al cargar bloques de atletas invitados",
  "syncErrorPendingWorkspaceBlocksDescription-string": "No hemos podido cargar los bloques de atletas invitados. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorWorkoutLibrary-string": "Error al cargar la librería de entrenamientos",
  "syncErrorWorkoutLibraryDescription-string": "No hemos podido cargar tu librería de entrenamientos. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorFoodLibrary-string": "Error al cargar la librería de alimentos",
  "syncErrorFoodLibraryDescription-string": "No hemos podido cargar tu librería de alimentos. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorNutritionPlans-string": "Error al cargar planes de nutrición",
  "syncErrorNutritionPlansDescription-string": "No hemos podido cargar tus planes de nutrición. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorApplicationForm-string": "Error al cargar el formulario de inscripciones",
  "syncErrorApplicationFormDescription-string": "No hemos podido cargar tu formulario de inscripciones. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorApplications-string": "Error al cargar inscripciones",
  "syncErrorApplicationsDescription-string": "No hemos podido cargar tus inscripciones. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorSubscription-string": "Error al cargar la suscripción",
  "syncErrorSubscriptionDescription-string": "No hemos podido cargar los detalles de tu suscripción. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncErrorLogo-string": "Error al cargar el logo",
  "syncErrorLogoDescription-string": "No hemos podido cargar tu logo. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "syncError-string": "Error de sincronización",
  "syncErrorGenericDescription-string": "No hemos podido sincronizar tus datos. Haz clic en el icono ! o recarga la página. Si sigue ocurriendo, contacta con soporte.",
  "invitationSent-string": "Invitación enviada",
  "invitationSentDescription-string": "Se ha enviado 1 invitación correctamente.",
  "blockCopiedInCalendar-string": "Bloque copiado en el calendario",
  "blockCopiedInCalendarDescription-string": "El bloque '{{blockName}}' se ha copiado.",
  "blockCopied-string": "Bloque copiado",
  "blockCopiedDescription-string": "El bloque '{{blockName}}' se ha copiado.",
  "blockCopiedToClient-string": "Bloque copiado al atleta",
  "blockCopiedToClientDescription-string": "El bloque '{{blockName}}' se ha copiado a {{clientName}}.",
  "nutritionPlanExportedToLibrary-string": "Plan nutricional movido a la librería",
  "nutritionPlanExportedToLibraryDescription-string": "El plan nutricional '{{planName}}' se ha guardado en tu librería.",
  "step1Completed-string": "Paso 1 completado",
  "step1CompletedDescription-string": "¡Enhorabuena! Has completado el segundo paso de la guía.",
  "step2Completed-string": "Primer ejercicio añadido",
  "step2CompletedDescription-string": "Has añadido tu primer ejercicio a un entrenamiento.",
  "step3Completed-string": "Paso 3 completado",
  "step3CompletedDescription-string": "¡Enhorabuena! Has invitado a tu primer atleta.",
  "workoutExportedToLibrary-string": "Entrenamiento exportado a la librería",
  "workoutExportedToLibraryDescription-string": "El entrenamiento '{{workoutName}}' se ha guardado en tu librería de entrenamientos.",
  "blockExportedToLibrary-string": "Bloque exportado a la librería",
  "blockExportedToLibraryDescription-string": "El bloque '{{blockName}}' se ha guardado en tu librería de bloques.",
  "invitationEmailError-string": "Invitación no entregada",
  "invitationEmailErrorDescription-string": "La invitación que intentamos enviar a {{clientEmail}} no se ha podido entregar. Comprueba que el correo es correcto e inténtalo de nuevo.",
  "connectionLost-string": "Estás sin conexión",
  "connectionLostDescription-string": "Se ha perdido tu conexión a internet. Los cambios se guardarán localmente y se sincronizarán cuando vuelvas a estar en línea.",
  "connectionRestored-string": "Has vuelto a estar en línea",
  "connectionRestoredDescription-string": "Tu conexión a internet se ha restablecido. Estamos sincronizando tus cambios. No cierres esta ventana hasta que todo se haya subido.",
  "offlineViewTitle-string": "Estás sin conexión",
  "offlineViewDescription-string": "Por favor, verifica tu conexión a internet e inténtalo de nuevo",
  "TITOL SIDE MENU": "",
  "home-string": "Inicio",
  "settings-string": "Ajustes",
  "configureSidebar-string": "Configurar barra lateral",
  "customizeNavigation-string": "Personaliza tu navegación",
  "customizeNavigationDescription-string": "Marca las apartados que quieres ver y arrástralos para cambiar el orden.",
  "athletes-string": "Atletas",
  "searchClient-string": "Buscar Atletas",
  "withoutActiveBlock-string": "Sin bloque activo",
  "clientWeekStatus-string": "Semana: {{blockCurrentWeek}} / {{blockWeeks}}",
  "startingWeekOf-string": "Empezando la semana del {{date}}",
  "notSet-string": "Sin establecer",
  "clientWeekStatusPrepared-string": "Semana: {{blockCurrentWeek}} / {{blockWeeks}}",
  "clientWeekStatusUnprepared-string": "Semana: <red>{{blockCurrentWeek}}</red> / {{blockWeeks}}",
  "pendingClients-string": "Atletas Pendientes",
  "completedClients-string": "Atletas Completados",
  "clientsWithBlockToCreate-string": "Atletas con Bloque a Crear",
  "clientsWithWeekToUpdate-string": "Atletas con Semana a Actualizar",
  "startsWeekIn-string": "Empieza semana en:",
  "endsWeekIn-string": "Termina semana en:",
  "freeTrialDayLeft-string": "Queda {{daysLeft}} día para que termine tu periodo de prueba",
  "freeTrialDaysLeft-string": "Quedan {{daysLeft}} días para que termine tu periodo de prueba",
  "youHaveMaxClients-string": "¡Tienes {{clientsLength}} atletas!",
  "useUpgradeDiscount-string": "Usa el código 'AmpliarPlan' y obtén un 30% de descuento durante 1 mes al mejorar tu plan.",
  "TITOL STRIPE": "",
  "manageSubscription-string": "Gestionar Suscripción",
  "reachedMaxClientsStripeView-string": "Has alcanzado el límite de atletas para tu suscripción.\n\nPara añadir más, haz clic en 'Gestionar Suscripción' para ampliarla fácilmente.",
  "stripeBottomText1-string": "Puedes cancelar tu suscripción mensual en cualquier momento antes de que finalice el periodo de facturación.",
  "stripeBottomText2-string": "Tu suscripción se renovará automáticamente cada mes.",
  "upTo5Athletes-string": "Hasta 5 atletas",
  "upTo15Athletes-string": "Hasta 15 atletas",
  "upTo30Athletes-string": "Hasta 30 atletas",
  "upTo50Athletes-string": "Hasta 50 atletas",
  "moreThan50Athletes-string": "Más de 50 atletas",
  "priceWithCurrency-string": "{{price}} €",
  "pricePerMonth-string": "{{price}} € / mes",
  "pricePerAthlete-string": "{{price}} € / atleta",
  "pricePerMonthDiscount-string": "/ mes",
  "stripePaymentFailedProblemText-string": "Ha habido un problema con la renovación de la suscripción",
  "stripePaymentFailedActiveSub-string": "Por favor, finaliza el pago para mantener tu suscripción activa.",
  "stripePaymentFailedNewSub-string": "Por favor, finaliza el pago para activar tu suscripción.",
  "stripePaymentFailedDoPayment-string": "Realizar el pago",
  "stripePaymentFailedAuxText-string": "O accede a la ",
  "stripePaymentFailedAccountConfig-string": "configuración de tu cuenta",
  "TITOL COACH DASHBOARD": "",
  "helloCoach-string": "Hola, {{coachName}}",
  "deleteAthleteAlertTitle-string": "ELIMINAR ATLETA",
  "deleteAthleteAlertText-string": "¿Estás seguro/a de eliminar el atleta?",
  "pendingInvitationProfileTitle-string": "Invitación pendiente de aceptación",
  "pendingInvitationProfileDescription-string": "Este atleta ha sido invitado y necesita descargar Efort y aceptar tu invitación. Puedes empezar a trabajar con este atleta ahora, y los cambios se entregarán automáticamente cuando acepte la invitación.",
  "deleteInvitation-string": "Eliminar invitación",
  "deleteInvitationAlertTitle-string": "ELIMINAR INVITACIÓN",
  "deleteInvitationAlertText-string": "¿Estás seguro/a de eliminar esta invitación?",
  "coachDashboardTypeToConfirmDelete-string": "Escribe \"{{expectedValue}}\" para confirmar esta eliminación.",
  "coachDashboardDeleteAthleteNamePlaceholder-string": "Escribe nombre y apellido del atleta",
  "coachDashboardDeleteInvitationEmailPlaceholder-string": "Escribe el email del atleta",
  "coachSettingsDeleteAccountEmailPlaceholder-string": "Escribe el email de tu cuenta",
  "pendingInvitationPlanificationBanner-string": "Ya puedes empezar a trabajar con este atleta. Tus cambios se enviarán automáticamente cuando acepte la invitación.",
  "dashboardBlockToCreateTooltip-string": "Atletas en la última semana del bloque",
  "dashboardWeekToUpdateTooltip-string": "Atletas en una semana intermedia del bloque",
  "nextCompetitions-string": "Próximas Competiciones",
  "emptyCompetitionsTitle-string": "No tienes competiciones próximas",
  "emptyCompetitionsText-string": "Ve al apartado de competiciones para crear nuevas",
  "noAthletesInCompetitionText-string": "No hay atletas en esta competición",
  "clientHeader-string": "ATLETA",
  "competitorHeader-string": "COMPETIDOR",
  "weekHeader-string": "SEMANA",
  "workoutsOfWeekHeader-string": "DÍAS DE ENTRENAMIENTO",
  "workoutsOfWeekTooltip-string": "Marca en qué días entrena cada atleta. Usa esta sección para encontrar rápidamente a los atletas que entrenan un día determinado.",
  "statusHeader-string": "ESTADO",
  "monHeader-string": "Lun",
  "tueHeader-string": "Mar",
  "wedHeader-string": "Mié",
  "thuHeader-string": "Jue",
  "friHeader-string": "Vie",
  "satHeader-string": "Sáb",
  "sunHeader-string": "Dom",
  "active-string": "Activo",
  "pending-string": "Invitado",
  "error-string": "Error",
  "invitationErrorTooltip-string": "Hubo un error al enviar la invitación, por favor verifica que el correo sea correcto, elimina esta invitación e inténtalo de nuevo.",
  "invitationPendingTooltip-string": "Se ha enviado un correo a este atleta. Debe descargar la app de Efort y aceptar tu invitación.",
  "openAthleteLegacyInvitationTooltip-string": "Solo las invitaciones nuevas te permiten abrir al atleta.",
  "inviteBlockNudgeTitle-string": "Empieza a crear un bloque para tu nuevo atleta",
  "inviteBlockNudgeCta-string": "Abrir atleta",
  "pendingBlocksBadgeLabel-string": "Pendientes: {{count}}",
  "pendingUserBlocksSectionTitle-string": "Bloques de atletas invitados",
  "pendingUserBlocksCountLabel-string": "{{count}} bloques",
  "pendingUserNutritionPlansSectionTitle-string": "Planes nutricionales de atletas invitados",
  "noResultsFound-string": "No se encontraron resultados",
  "noResultsFoundDescription-string": "No pudimos encontrar ningún atleta que coincida con tu búsqueda. Intenta ajustar los términos de búsqueda.",
  "TITOL CONVIDAR ATLETES": "",
  "addClient-string": "Añadir Atleta",
  "addClientText-string": "Los atletas recibirán una invitación para descargarse la aplicación de Efort.",
  "emailAlreadyInUseText-string": "El atleta introducido ya está invitado",
  "userAlreadyHasCoachText-string": "El atleta ya tiene un entrenador asociado",
  "errorSendingEmailText-string": "El correo no existe",
  "emailSentText-string": "¡Invitación enviada!",
  "emailPlaceholder-string": "atleta@gmail.com",
  "send-string": "Enviar",
  "toDownloadGuide-string": "para descargar la guía de uso para atletas.",
  "clickHere-string": "Haz click aquí",
  "inviteAthlete-string": "Invitar Atletas",
  "inviteAthleteSubtitle-string": "Envía invitaciones a tus atletas. Recibirán un correo para descargar la app de Efort y aceptar tu invitación.",
  "previewAthleteApp-string": "Ver app de atleta",
  "athleteUserGuide-string": "Guía de uso para atletas (PDF)",
  "athleteEmailAddresses-string": "Direcciones de correo de atletas",
  "typeEmailHint-string": "Escribe un correo y pulsa Enter para añadir más",
  "invalidEmailFormat-string": "Formato de correo no válido",
  "sendInvitations-string": "Enviar invitaciones",
  "alreadyInvited-string": "Ya tiene una invitación pendiente",
  "alreadyHasCoach-string": "Ya tiene entrenador",
  "invitationsSent-string": "Invitaciones enviadas",
  "invitationsSentDescription-string": "Se han enviado {{count}} invitaciones correctamente.",
  "errorSendingInvitations-string": "Error al enviar las invitaciones",
  "TITOL COACH LIBRARY": "",
  "library-string": "Librería",
  "workouts-string": "Entrenamientos",
  "forms-string": "Cuestionarios",
  "searchWorkout-string": "Buscar Entrenamientos",
  "searchBlock-string": "Buscar Bloques",
  "newWorkout-string": "Nuevo Entrenamiento",
  "newWorkoutCount-string": "Nuevo Entrenamiento ({{count}})",
  "changeWorkoutNameTitle-string": "Cambia el nombre del entrenamiento",
  "createWorkoutTitle-string": "Crea un nuevo entrenamiento",
  "exerciseCountOne-string": "{{count}} Ejercicio",
  "exerciseCount-string": "{{count}} Ejercicios",
  "firstExercise-string": "Primer ejercicio",
  "secondExercise-string": "Segundo ejercicio",
  "emptyWorkoutsTitle-string": "Sin Entrenamientos",
  "createTemplateWorkoutsText-string": "Crea plantillas de entrenamiento",
  "emptyBlocksTitle-string": "Sin Bloques",
  "createTemplateBlocksText-string": "Crea plantillas de bloques",
  "workoutCountOne-string": "{{count}} Entrenamiento",
  "workoutCount-string": "{{count}} Entrenamientos",
  "deleteWorkoutAlertTitle-string": "ELIMINAR ENTRENAMIENTO",
  "deleteWorkoutAlertText-string": "¿Estás seguro/a de eliminar el entrenamiento de la librería?",
  "deletePendingBlockAlertTitle-string": "ELIMINAR BLOQUE",
  "deletePendingBlockAlertText-string": "¿Estás seguro/a de que quieres eliminar el bloque '{{itemName}}'?",
  "notes-string": "Notas",
  "privateNotePlaceholder-string": "Nota privada...",
  "searchAttributes-string": "Buscar Modificadores",
  "searchExercise-string": "Buscar Ejercicios",
  "selectExercise-string": "Selecciona un ejercicio",
  "selectManually-string": "Seleccionar ejercicio manualmente",
  "deleteExercise-string": "Eliminar ejercicio",
  "recentlyUsed-string": "Usados recientemente",
  "lastUpdated-string": "Última actualización",
  "suggestions-string": "Sugerencias",
  "navigate-string": "Navegar",
  "notFindingWhatYouWant-string": "¿No encuentras lo que buscas?",
  "selectExerciseManually-string": "Seleccionar ejercicio manualmente",
  "searchForm-string": "Buscar Cuestionarios",
  "newForm-string": "Nuevo Cuestionario",
  "initialForm-string": "Cuestionario inicial",
  "weeklyForms-string": "Cuestionarios semanales",
  "blockForms-string": "Cuestionarios de final de bloque",
  "default-string": "Predeterminado",
  "questionCountOne-string": "{{count}} Pregunta",
  "questionCount-string": "{{count}} Preguntas",
  "set-string": "Establecer",
  "setAsDefault-string": "Establecer como predeterminado para nuevos atletas",
  "withoutWeeklyForms-string": "Sin Cuestionarios Semanales",
  "createWeeklyForms-string": "Crea cuestionarios que tus atletas recibirán automáticamente cada semana",
  "withoutBlockForms-string": "Sin Cuestionarios de Final de Bloque",
  "createBlockForms-string": "Crea cuestionarios que tus atletas recibirán automáticamente al final de cada bloque de entrenamiento",
  "selectAll-string": "Seleccionar todos",
  "unselectAll-string": "Deseleccionar todos",
  "editForm-string": "Editar Cuestionario",
  "createForm-string": "Crea un nuevo cuestionario",
  "deleteForm-string": "Eliminar formulario",
  "initialFormText1-string": "El formulario inicial lo responden los atletas al aceptar tu invitación.",
  "initialFormText2-string": "Además de tus preguntas, incluirán su nombre, apellido y género.",
  "initialFormType-string": "Inicial",
  "weeklyFormType-string": "Semanal",
  "blockFormType-string": "Fin de bloque",
  "emptyClientsTitle-string": "Sin Atletas",
  "addNewClientsText-string": "Añade nuevos atletas",
  "noAthletesFoundText-string": "No se han encontrado atletas",
  "addQuestion-string": "Añadir pregunta",
  "addSection-string": "Añadir Sección",
  "nameOfSection-string": "Nombre de la sección",
  "deleteSection-string": "Eliminar Sección",
  "questionPlaceholderText-string": "Escribe la pregunta y escoge el tipo de respuesta",
  "questionTextType-string": "Texto",
  "questionNumberType-string": "Número (1-5)",
  "deleteFormAlertTitle-string": "ELIMINAR CUESTIONARIO",
  "deleteFormAlertText-string": "¿Estás seguro/a de eliminar el cuestionario de la librería?",
  "setDefaultFormAlertTitle-string": "ESTABLECER COMO PREDETERMINADO",
  "setDefaultFormAlertText-string": "¿Estás seguro/a de establecer el formulario como predeterminado?\n\nEsto hará que se aplique a todos los atletas nuevos.",
  "mondayLetter-string": "L",
  "tuesdayLetter-string": "M",
  "wednesdayLetter-string": "X",
  "thursdayLetter-string": "J",
  "fridayLetter-string": "V",
  "saturdayLetter-string": "S",
  "sundayLetter-string": "D",
  "TITOL FACTURACIO": "",
  "billing-string": "Facturación",
  "beginningOfQuotaHeader-string": "INICIO DE CUOTA",
  "feeHeader-string": "TARIFA",
  "quotaTypeHeader-string": "TIPO DE CUOTA",
  "endOfQuotaHeader-string": "FIN DE CUOTA",
  "toPayHeader-string": "POR PAGAR",
  "actionsHeader-string": "ACCIONES",
  "totalToCollect-string": "TOTAL POR COBRAR:",
  "feeWithCurrency-string": "{{fee}}€",
  "renewPlan-string": "Renovar plan",
  "viewHistory-string": "Ver historial",
  "hideHistory-string": "Ocultar historial",
  "copyTargetSets-string": "Copiar series pautadas",
  "owedQuotasRow-string": "{{amount}}€ ({{quotas}} cuotas)",
  "monthly-string": "Mensual",
  "quarterly-string": "Trimestral",
  "semestral-string": "Semestral",
  "annual-string": "Anual",
  "Mensual": "Mensual",
  "Trimestral": "Trimestral",
  "Semestral": "Semestral",
  "Anual": "Anual",
  "renew-string": "Renovar",
  "nextPaymentWillBe-string": "El siguiente pago será: {{newDay}} / {{endMonthReturn}} / {{endYearReturn}}",
  "renewClientsQuota-string": "Renovar cuota de {{name}}",
  "feeDots-string": "Tarifa:",
  "quotaTypeDots-string": "Tipo de cuota:",
  "beginningOfQuotaDots-string": "Inicio de la cuota:",
  "feeIsVoid-string": "La cuota debe tener una tarifa.",
  "quotaHistoryOfClient-string": "Historial de cuotas de {{name}}",
  "TITOL COMPETICIONS": "",
  "competitions-string": "Competiciones",
  "searchCompetition-string": "Buscar Competiciones",
  "newCompetition-string": "Nueva Competición",
  "emptyCompetitionsLibraryTitle-string": "Sin Competiciones",
  "emptyCompetitionsLibraryText-string": "Crea competiciones y planifica los intentos de tus atletas",
  "deleteCompetitionAlertTitle-string": "ELIMINAR COMPETICIÓN",
  "deleteCompetitionAlertText-string": "¿Estás seguro/a de eliminar la competición?",
  "alreadyHappened-string": "Ya ha pasado",
  "isToday-string": "Es hoy",
  "isTodayName-string": "Hoy es {{name}}",
  "isThisWeek-string": "Es esta semana",
  "isThisWeekName-string": "Esta semana es {{name}}",
  "oneWeekLeft-string": "Falta 1 semana",
  "oneWeekLeftName-string": "Falta 1 semana para {{name}}",
  "someWeeksLeft-string": "Faltan {{weeks}} semanas",
  "someWeeksLeftName-string": "Faltan {{weeks}} semanas para {{name}}",
  "totalValidAttempts-string": "{{totalValidAttempts}}/{{totalAttempts}} intentos",
  "totalValidThirdAttempts-string": "{{totalValidAttempts}}/{{totalAttempts}} terceros intentos",
  "men-string": "Masculino",
  "women-string": "Femenino",
  "nameOfCompetition-string": "Nombre de la competición",
  "category-string": "Categoría",
  "level-string": "Nivel",
  "federation-string": "Federación",
  "searchFederation-string": "Buscar federación",
  "noFederationsFound-string": "No se han encontrado federaciones",
  "competitionFederationChangeAlertTitle-string": "CAMBIAR FEDERACIÓN",
  "competitionFederationChangeAlertText-string": "Cambiar de federación reasignará las categorías de peso de tus atletas a la categoría válida más cercana. Podrás ajustarlas después.",
  "competitionFederationRemapToastTitle-string": "Categorías de peso actualizadas",
  "competitionFederationRemapToastDescription-string": "Se han actualizado {{count}} categorías de atletas tras cambiar la federación.",
  "emptyCategoryTitle-string": "Sin Categoría",
  "emptyCategoryText-string": "Selecciona una categoría para añadir a tus atletas a la competición",
  "competitionTime-string": "Hora competición",
  "weightInTime-string": "Hora pesaje",
  "firstTry-string": "1r intento",
  "secondTry-string": "2o intento",
  "thirdTry-string": "3r intento",
  "warmups-string": "Aproximaciones",
  "minimumTotal-string": "Marca mínima",
  "goodTotal-string": "Total bueno",
  "mediumTotal-string": "Total medio",
  "badTotal-string": "Total malo",
  "difference-string": "Diferencia",
  "competitionNotes-string": "Notas de la competición",
  "firstGoal-string": "Primer objetivo de la competición",
  "secondGoal-string": "Segundo objetivo de la competición",
  "thirdGoal-string": "Tercer objetivo de la competición",
  "competitionRecap-string": "Resultados de la competición",
  "competitionTotal-string": "Total de la competición:",
  "competitionRecapNotes-string": "Notas sobre el resultado de la competición",
  "TITOL AJUSTES": "",
  "profile-string": "Perfil",
  "name-string": "Nombre",
  "surname-string": "Apellido",
  "email-string": "Correo electrónico",
  "dietaryPreference-string": "Preferencia dietética",
  "allergens-string": "Alérgenos",
  "nutritionFoodContainsAllergens-string": "Contiene alérgenos",
  "nutritionFoodDietarySuitability-string": "Compatibilidad dietética",
  "nutritionAllergenEgg-string": "Huevo",
  "nutritionAllergenFish-string": "Pescado",
  "nutritionAllergenGluten-string": "Gluten",
  "nutritionAllergenMilk-string": "Leche",
  "nutritionAllergenTreeNut-string": "Frutos secos",
  "nutritionAllergenPeanut-string": "Cacahuete",
  "nutritionAllergenSesame-string": "Sésamo",
  "nutritionAllergenShellfish-string": "Marisco",
  "nutritionAllergenSoy-string": "Soja",
  "preferences-string": "Preferencias",
  "exerciseUnit-string": "Unidad de ejercicios",
  "language-string": "Idioma",
  "resetPredefinedExercises-string": "Restaurar ejercicios predefinidos",
  "resetPredefinedAttributes-string": "Restaurar modificadores predefinidos",
  "offline-string": "Modo Offline",
  "downloadAllAthletes-string": "Descarga todos los atletas",
  "downloadAllAthletesToMakeAvailable-string": "Descarga los datos de todos los atletas para que estén disponibles sin conexión.",
  "download-string": "Descargar",
  "account-string": "Cuenta",
  "logOut-string": "Cerrar Sesión",
  "useAnotherAccount-string": "Usar otra cuenta",
  "deleteAccount-string": "Eliminar Cuenta",
  "subscription-string": "Suscripción",
  "resetButton-string": "Restaurar",
  "yourLogo-string": "Tu logo",
  "uploadYourLogo-string": "Haz clic aquí para\nsubir tu logo",
  "support-string": "Soporte",
  "learnAndUpdates-string": "Aprende y Novedades",
  "reportProblem-string": "Informar de un problema",
  "reportProblemText-string": "¿Necesitas ayuda? Escríbenos en Instagram a @efortapp",
  "sendFeedbackSettings-string": "Enviar feedback",
  "contactUs-string": "Contáctanos",
  "resetExercisesAlertTitle-string": "RESTAURAR EJERCICIOS PREDEFINIDOS",
  "resetExercisesAlertText-string": "¿Estás seguro/a de restaurar los ejercicios predefinidos?\n\nNo se eliminarán los que te hayas creado.",
  "resetAttributesAlertTitle-string": "RESTAURAR MODIFICADORES PREDEFINIDOS",
  "resetAttributesAlertText-string": "¿Estás seguro/a de restaurar los modificadores predefinidos?\n\nNo se eliminarán los que te hayas creado.",
  "deleteAccountAlertTitle-string": "ELIMINAR CUENTA",
  "deleteAccountAlertText-string": "¿Estás seguro/a de que quieres eliminar la cuenta?\n\nPerderás toda la información que tengas.",
  "changeLanguageAlertTitle-string": "CAMBIAR IDIOMA DE EJERCICIOS",
  "changeLanguageAlertText-string": "Cambiar el idioma de los ejercicios puede tardar unos minutos y podría interrumpir a los atletas que están usando la app. ¿Deseas continuar?",
  "deleteLogoAlertTitle-string": "ELIMINAR LOGO",
  "deleteLogoAlertText-string": "¿Estás seguro/a de que quieres eliminar tu logo?",
  "uploadFailedText-string": "Error al subir el archivo. Por favor, inténtalo de nuevo.\n",
  "selectImageFileText-string": "Por favor selecciona una imagen.\n",
  "imageSizeLimitText-string": "La imagen seleccionada supera el límite de tamaño de 5MB. Por favor, selecciona una imagen más pequeña.\n",
  "uploadErrorTitle-string": "ERROR AL SUBIR EL ARCHIVO\n",
  "preferenceDefaultBlockView-string": "Vista predeterminada del bloque",
  "preferenceDefaultBlockViewTooltip-string": "Elige qué vista se abre primero al abrir un bloque: Entrenamientos o Panel.",
  "TITOL INSCRIPCIONS": "",
  "applications-string": "Inscripciones",
  "required-string": "Obligatoria",
  "notRequired-string": "No obligatoria",
  "requiredInfo-string": "Información obligatoria",
  "nutritionFoodRequiredFields-string": "Rellena todos los campos obligatorios",
  "directoryTaken-string": "El link ya está en uso. Prueba con otro.",
  "yourAnswer-string": "Tu respuesta",
  "submit-string": "Enviar",
  "clear-string": "Borrar",
  "clearFormAlertTitle-string": "BORRAR FORMULARIO",
  "clearFormAlertText-string": "Se eliminarán permanentemente tus respuestas de todas las preguntas.",
  "applicationSentTitle-string": "SOLICITUD ENVIADA",
  "applicationSentText-string": "Tu inscripción se ha enviado correctamente a {{coachName}}. La revisará y se pondrá en contacto contigo pronto.",
  "nameDots-string": "Nombre: ",
  "surnameDots-string": "Apellido: ",
  "emailDots-string": "Correo electrónico: ",
  "deleteApplicationAlertTitle-string": "ELIMINAR INSCRIPCIÓN",
  "deleteApplicationAlertText-string": "¿Estás seguro/a de que quieres eliminar la inscripción?",
  "deleteCoachApplicationAlertTitle-string": "ELIMINAR FORMULARIO DE INSCRIPCIÓN",
  "deleteCoachApplicationAlertText-string": "¿Estás seguro/a de que quieres eliminar el formulario de inscripción?",
  "ApplicationStep1-string": "Escribe el link al que quieres que se dirijan los atletas para rellenar el formulario",
  "ApplicationStep2-string": "Edita el formulario y añade las preguntas que quieras",
  "ApplicationStep3-string": "¡Copia el enlace y compártelo!",
  "followTheseSteps-string": "Sigue los siguientes pasos para empezar a recibir nuevas inscripciones",
  "registrationForm-string": "Formulario de Inscripción",
  "noNewApplications-string": "No tienes nuevas inscripciones",
  "whenNewApplication-string": "Cuando alguien rellene tu formulario de inscripción, lo recibirás aquí",
  "questionPlaceholderFormApplicationsText-string": "Escribe la pregunta e indica si es obligatoria",
  "requiredFieldsNotFilled-string": "Debes responder todas las preguntas obligatorias",
  "yourBrand-string": "tu-marca",
  "TITOL CLIENT DASHBOARD": "",
  "currentBlock-string": "BLOQUE",
  "noScheduledWorkouts-string": "No hay entrenamientos programados esta semana",
  "weekOfTotal-string": "Semana",
  "of-string": "de",
  "weeksPendingToCreate-string": "semanas pendientes de crear",
  "weekPendingToCreate-string": "semana pendiente de crear",
  "oneWeekPlanned-string": "1 semana planificada",
  "weeksPlanned-string": "{{count}} semanas planificadas",
  "weeksPlannedOf-string": "{{created}} / {{total}} semanas planificadas",
  "nextCompetition-string": "PRÓXIMA COMPETICIÓN",
  "thisWeek-string": "Esta semana",
  "oneWeekOut-string": "En 1 semana",
  "weeksOut-string": "semanas",
  "workoutsTitle-string": "ENTRENAMIENTOS",
  "week-string": "Semana",
  "notesTitle-string": "NOTAS",
  "privateNote-string": "NOTA PRIVADA",
  "privateNoteInfo-string": "Usa la nota privada para anotaciones sobre el atleta o recordatorios. Esta nota se mantiene entre semanas y bloques.",
  "onlyVisibleToYou-string": "Solo visible para ti...",
  "dailyNotes-string": "NOTAS DIARIAS",
  "dailyNotesInfo-string": "Las notas diarias aparecerán en la app del atleta en la página de inicio y en el día correspondiente del calendario",
  "addExercisesBeforeCreatingWeek-string": "Añade ejercicios a todos los entrenamientos de la semana antes de crear una semana nueva.",
  "createWorkoutsBeforeAddingToCalendar-string": "Crea todos los entrenamientos de la semana antes de añadirlos al calendario.",
  "noteForDay-string": "Nota para {{day}}...",
  "chatTitle-string": "CHAT",
  "messagesSection-string": "Mensajes",
  "new-string": "nuevo",
  "videosSection-string": "Vídeos",
  "moreMessages-string": "+{{count}} mensajes más",
  "moreVideos-string": "+{{count}} vídeos más",
  "formsTitle-string": "CUESTIONARIOS",
  "blockForm-string": "Cuestionario de fin de bloque",
  "weeklyForm-string": "Cuestionario semanal",
  "review-string": "Revisar",
  "completed-string": "Completado",
  "notCompleted-string": "No completado",
  "notSent-string": "No enviado",
  "bodyweightTitle-string": "PESO CORPORAL",
  "weeklyAverage-string": "Media Semanal",
  "vsPriorWeek-string": "vs. semana anterior",
  "lastWeeklyAverage-string": "Última Media Semanal",
  "weekOf-string": "semana de",
  "noDataYet-string": "Sin datos todavía",
  "bodyweightTrendsInfo-string": "Las tendencias de peso corporal aparecerán aquí una vez que el atleta comience a registrarlo",
  "tracTrendsInfo-string": "Las tendencias de Trac aparecerán aquí una vez que el atleta lo registre",
  "hideNote-string": "Ocultar Nota",
  "soreness-string": "Fatiga",
  "recoveryContext-string": "Recuperación y Contexto",
  "legSoreness-string": "Fatiga de Pierna",
  "pushSoreness-string": "Fatiga de Empuje",
  "pullSoreness-string": "Fatiga de Tracción",
  "perceivedRecovery-string": "Recuperación Percibida",
  "motivation-string": "Motivación",
  "technicalComfort-string": "Comodidad Técnica",
  "sleepQualityNutrition-string": "Descanso/Alimentación",
  "soreness1-string": "Fatiga severa, muy incómoda",
  "soreness2-string": "Fatiga significativa, incómoda",
  "soreness3-string": "Fatiga moderada, perceptible pero manejable",
  "soreness4-string": "Leve fatiga, apenas perceptible",
  "soreness5-string": "Sin fatiga ni rigidez",
  "perceivedRecovery1-string": "Completamente exhausto",
  "perceivedRecovery2-string": "Muy cansado",
  "perceivedRecovery3-string": "Algo cansado",
  "perceivedRecovery4-string": "Moderadamente fresco",
  "perceivedRecovery5-string": "Muy fresco",
  "motivation1-string": "Sin motivación",
  "motivation2-string": "Ligeramente motivado",
  "motivation3-string": "Algo motivado",
  "motivation4-string": "Moderadamente motivado",
  "motivation5-string": "Muy motivado",
  "sleepQuality1-string": "Alimentación y descanso deficientes",
  "sleepQuality2-string": "Alimentación o descanso regulares",
  "sleepQuality3-string": "Alimentación y descanso aceptables",
  "sleepQuality4-string": "Buena alimentación y descanso",
  "sleepQuality5-string": "Óptima alimentación y descanso",
  "technicalComfort1-string": "Muy incómodo técnicamente",
  "technicalComfort2-string": "Un poco incómodo técnicamente",
  "technicalComfort3-string": "Algo cómodo técnicamente",
  "technicalComfort4-string": "Mayormente cómodo técnicamente",
  "technicalComfort5-string": "Muy cómodo técnicamente",
  "summary-string": "Resumen",
  "addNote-string": "Añadir Nota",
  "deleteNote-string": "Eliminar Nota",
  "noData-string": "Sin datos",
  "bodyweight-string": "Peso Corporal",
  "exerciseQuestionMarkText-string": "Puedes elegir los ejercicios en el panel del bloque",
  "wOfExercise-string": "S{{week}}",
  "competition-string": "Competición",
  "note-string": "Nota",
  "workout-string": "Entrenamiento",
  "weekOfWorkout-string": "Semana: {{week}}",
  "noExercisesYet-string": "Aún no hay ejercicios",
  "addOneOrPasteFromClipboard-string": "Añade uno o pega desde el portapapeles",
  "selectExercisePlaceholder-string": "Seleccionar...",
  "editWorkoutName-string": "Editar nombre del entrenamiento",
  "copyWorkoutExercises-string": "Copiar ejercicios del entrenamiento",
  "moveWorkoutUp-string": "Mover entrenamiento hacia arriba",
  "moveWorkoutDown-string": "Mover entrenamiento hacia abajo",
  "deleteWorkoutTooltip-string": "Eliminar entrenamiento",
  "deleteWorkoutFromCalendar-string": "Eliminar del calendario",
  "deleteWorkoutFromCalendarAlertText-string": "¿Estás seguro/a de eliminar el entrenamiento del calendario?",
  "pasteExercise-string": "Pegar ejercicio",
  "pasteExercises-string": "Pegar ejercicios",
  "moreOptions-string": "Más opciones",
  "todayBodyweight-string": "Hoy: {{bodyweight}}",
  "todayTrac-string": "Hoy: {{count}}/20",
  "calendar-string": "Calendario",
  "january-string": "Enero",
  "february-string": "Febrero",
  "march-string": "Marzo",
  "april-string": "Abril",
  "may-string": "Mayo",
  "june-string": "Junio",
  "july-string": "Julio",
  "august-string": "Agosto",
  "september-string": "Septiembre",
  "october-string": "Octubre",
  "november-string": "Noviembre",
  "december-string": "Diciembre",
  "block-string": "BLOQUE",
  "weeks-string": "SEMANAS",
  "startDate-string": "FECHA INICIO",
  "endDate-string": "FECHA FIN",
  "willStartWeekOf-string": "Empezará la semana del {{date}}",
  "thereIsABlockAlready-string": "Ya hay un bloque en el calendario durante esas semanas",
  "haveToAddNameToBlock-string": "Debes añadir un nombre al bloque",
  "weeksDots-string": "Semanas:",
  "label-string": "Carpeta",
  "labelEmptyText-string": "No hay carpetas con ese nombre. Se creará una nueva al presionar guardar.",
  "splitInfoText-string": "El split mostrado se basa en las fechas de los entrenamientos de la primera semana",
  "noSlotsForWeek-string": "La semana {{week}} todavía no tiene ningún slot. Crea nuevos slots abajo.",
  "dontWantMoreSlots-string": "¿Has terminado de añadir slots?",
  "goToWorkoutsAddAccessories-string": "Ve a Entrenamientos para añadir ejercicios accesorios",
  "hideBlocksWithoutDate-string": "Ocultar bloques sin fecha",
  "showBlocksWithoutDate-string": "Mostrar bloques sin fecha",
  "noBlocksThisYear-string": "Sin Bloques Para Este Año",
  "dragToCreateBlock-string": "Arrastra entre dos fechas para crear un bloque en las semanas seleccionadas",
  "cantMoveBlockWithDatedWorkouts-string": "No es posible mover un bloque que ya tiene entrenamientos con fecha asignada.",
  "blockWithoutDate-string": "Bloques Sin Fecha",
  "calendarBlocksUpdateInfo-string": "Los bloques creados desde el calendario también aparecerán aquí.",
  "planBlocksSequence-string": "Crea bloques de entrenamiento en el calendario arrastrando entre dos fechas. Luego abre cada bloque desde la sección de Planificación.",
  "addVideoLinkMenu-string": "Añadir enlace de vídeo",
  "editVideoLinkMenu-string": "Editar enlace de vídeo",
  "duplicateExerciseMenu-string": "Duplicar",
  "linkExerciseToSlotMenu-string": "Vincular ejercicio a slot",
  "unlinkExerciseFromSlotMenu-string": "Desvincular ejercicio de slot",
  "linkSlotInfo-string": "Al vincular un ejercicio a un slot podrás trabajar con ese ejercicio desde el panel del bloque.",
  "addWorkout-string": "Añadir entrenamiento",
  "emptyBlocksInMacroTitle-string": "Selecciona un bloque",
  "emptyBlocksInMacroText-string": "Selecciona un bloque para mostrar sus slots y protocolos aquí",
  "actualWithDataCopyCalendarBlockTitle-string": "NO SE PUEDE COPIAR EL BLOQUE",
  "actualWithDataCopyCalendarBlockText-string": "El bloque '{{blockName}}' ya tiene series con datos. Elimina las series antes de copiar el bloque.",
  "copyCalendarBlockWarningTitle-string": "COPIAR BLOQUE",
  "copyCalendarBlockWarningText-string": "¿Reemplazar todos los entrenamientos y slots en '{{targetBlockName}}' por los de '{{sourceBlockName}}'?",
  "copyCalendarBlockDoubleConfirmationText-string": "Sobrescribir todos los entrenamientos existentes.",
  "dropCalendarBlockToCopyTitle-string": "Arrastra Aquí para Copiar el Bloque",
  "dropCalendarBlockToCopyText-string": "Suelta el bloque aquí para copiar sus entrenamientos y slots al bloque destino",
  "withoutForms-string": "Sin Cuestionarios",
  "addFormsFromLibrary-string": "Añade cuestionarios al atleta desde la librería",
  "pendingClientFormsAfterAcceptance-string": "Los cuestionarios aparecerán cuando el atleta acepte la invitación.",
  "weekly-string": "Semanales",
  "endOfBlock-string": "Fin de Bloque",
  "answersCountOne-string": "{{count}} Respuesta",
  "answersCount-string": "{{count}} Respuestas",
  "stats-string": "Estadísticas",
  "blocks-string": "Bloques",
  "unlabeledFolder-string": "Sin carpeta",
  "exercises-string": "Ejercicios",
  "startDots-string": "Inicio:",
  "endDots-string": "Fin:",
  "weekWithNumber-string": "Semana {{week}}",
  "addExercise-string": "Añadir ejercicio",
  "e1rm-string": "1RM Estimado",
  "tonnage-string": "Tonelaje",
  "intensityPercentage-string": "Porcentaje de intensidad",
  "numberOfLifts-string": "Número de levantamientos",
  "numberOfSets-string": "Número de series",
  "stressIndex-string": "Stress Index",
  "statsMetricE1RMTooltip-string": "Mayor 1RM estimado de cualquier serie registrada.",
  "statsMetricStressIndexTooltip-string": "Stress Index total de todas las series (suma del estrés de cada serie según el RPE).",
  "statsMetricTonnageTooltip-string": "Tonelaje total (peso × repeticiones) sumado entre todas las series.",
  "statsMetricIntensityPctTooltip-string": "Promedio de lo pesadas que fueron las series, expresado como % de tu 1RM estimado.",
  "statsMetricNumberOfLiftsTooltip-string": "Total de repeticiones realizadas (todas las series combinadas).",
  "statsMetricNumberOfSetsTooltip-string": "Total de series realizadas.",
  "statsMetricExertionLoadTooltip-string": "Carga de Esfuerzo (XL) total, combinando repeticiones y RPE/RIR para estimar el esfuerzo.",
  "statisticsChartNoDataInfo-string": "Selecciona un ejercicio para ver el gráfico.",
  "statisticsRangeLabel-string": "Rango:",
  "statisticsStartLabel-string": "Inicio:",
  "statisticsEndLabel-string": "Fin:",
  "statisticsPresetLast3Months-string": "Últimos 3 meses",
  "statisticsPresetLast6Months-string": "Últimos 6 meses",
  "statisticsPresetYearToDate-string": "Año en curso",
  "statisticsPresetAllTime-string": "Todo el tiempo",
  "statisticsPresetSelectRange-string": "Selecciona rango",
  "statisticsWeekNumber-string": "Semana {{week}}",
  "statisticsHiddenBlocks-string_one": "{{count}} oculto",
  "statisticsHiddenBlocks-string_other": "{{count}} ocultos",
  "statisticsMaxSelectionReached-string": "Máximo {{count}} alcanzado",
  "statisticsBlocksTitle-string": "Bloques",
  "statisticsExercisesTitle-string": "Ejercicios",
  "statisticsAddExerciseTooltip-string": "Añadir un ejercicio",
  "statisticsUnselectToAdd-string": "Deselecciona ejercicios para añadir otro",
  "statisticsAllSlots-string": "Todos los slots",
  "statisticsHelperSelectBlockOrExercises-string": "Selecciona un bloque o añade ejercicios para comenzar",
  "statisticsHelperAnalyzingSingleAcrossTime-string": "Analizando {{exercise}} a lo largo del tiempo",
  "statisticsHelperComparingExercisesAcrossTime-string": "Comparando {{count}} ejercicios a lo largo del tiempo",
  "statisticsHelperSelectOneExercise-string": "Selecciona un ejercicio para analizar",
  "statisticsHelperAnalyzingInBlock-string": "Analizando {{exercise}} en {{block}}",
  "statisticsHelperComparingExercisesInBlock-string": "Comparando {{count}} ejercicios en {{block}}",
  "statisticsHelperSelectExerciseToCompare-string": "Selecciona un ejercicio para comparar",
  "statisticsHelperComparingExerciseAcrossBlocks-string": "Comparando {{exercise}} en {{blockCount}} bloques",
  "statisticsHelperComparingExercisesAcrossBlocks-string": "Comparando ejercicios en {{blockCount}} bloques",
  "statisticsHelperSelectData-string": "Selecciona datos para analizar",
  "statisticsFallbackBlockName-string": "Bloque",
  "statisticsFallbackExerciseName-string": "Ejercicio",
  "statisticsMetricNone-string": "Ninguno",
  "statisticsProtocolSlotNotSharedTooltip-string": "No todos los bloques seleccionados tienen este slot",
  "tooltipHiddenEntry-string": "+{{count}} elemento",
  "tooltipHiddenEntries-string": "+{{count}} elementos",
  "dateHeader-string": "FECHA",
  "exerciseHeader-string": "EJERCICIO",
  "setsHeader-string": "SERIES",
  "blockHeader-string": "BLOQUE",
  "metricsHeader-string": "MÉTRICAS",
  "sets-string": "Series",
  "setSingular-string": "Serie",
  "clientName-string": "Nombre del cliente",
  "contactNumber-string": "Número de contacto",
  "phone-string": "Móvil",
  "gender-string": "Género",
  "male-string": "Masculino",
  "female-string": "Femenino",
  "notesForCoach-string": "Notas para el entrenador",
  "deleteClient-string": "Eliminar Atleta",
  "deleteSampleAthlete-string": "Eliminar Atleta de Ejemplo",
  "deleteClientAlertTitle-string": "ELIMINAR ATLETA",
  "deleteClientAlertText-string": "¿Estás seguro/a de eliminar al atleta? Todos sus mensajes del chat, vídeos, audios e imágenes se eliminarán permanentemente.",
  "planification-string": "Planificación",
  "openBlockInProgram-string": "Abrir bloque en Planificación",
  "blockSummary-string": "Resumen del Bloque",
  "openBlockSummary-string": "Abrir resumen del bloque",
  "withoutBlocks-string": "Sin Bloques",
  "withoutBlocksText-string": "Crea tu primer bloque de entrenamiento",
  "noMatchingBlocks-string": "No hay bloques que coincidan",
  "noMatchingBlocksSubtitle-string": "Intenta con otro término de búsqueda",
  "makeActive-string": "Establecer como activo",
  "editBlock-string": "Editar bloque",
  "copyBlock-string": "Duplicar primera semana del bloque",
  "copyFullBlock-string": "Duplicar bloque entero",
  "copyToAnotherClient-string": "Copiar a otro atleta",
  "importFromLibrary-string": "Importar desde la librería",
  "copyToAClient-string": "Copiar a un atleta",
  "newBlock-string": "Nuevo Bloque",
  "createBlock-string": "Crea un nuevo bloque",
  "copyOf-string": "Copia de",
  "editMacro-string": "Editar carpeta",
  "editFolderName-string": "Editar nombre de carpeta",
  "createBlockInFolder-string": "Crear bloque en carpeta",
  "folderRenameError-string": "Algunos bloques de la carpeta no se pudieron renombrar. Inténtalo de nuevo.",
  "disableBlockFolderMoveSearchActive-string": "Borra la búsqueda para mover bloques entre carpetas.",
  "blockMovedFolderTitle-string": "Bloque movido",
  "blockMovedFolderDescription-string": "\"{{blockName}}\" movido a {{folderName}}.",
  "blockMoveFolderErrorTitle-string": "No se pudo mover el bloque",
  "blockMoveFolderErrorDescription-string": "El bloque volvió a su carpeta anterior.",
  "macrocycleTooltip-string": "Una carpeta es una etiqueta que puedes añadir a los bloques para agrupar varios bloques.",
  "macrocyclePlaceholder-string": "Nombre de la carpeta...",
  "maximumWeeksReachedTitle-string": "NÚMERO MÁXIMO DE SEMANAS ALCANZADO",
  "maximumWeeksReachedText-string": "Has alcanzado el número máximo de semanas permitido para un bloque de entrenamiento",
  "slotsNotAddedToWeekTitle-string": "SLOTS NO ASIGNADOS",
  "slotsNotAddedToWeekText-string": "Algunos slots no se han añadido a ningún entrenamiento de la semana {{week}}. ¿Estás seguro/a de que deseas crear una nueva semana?",
  "slotsNotAddedToWeekAllWeeksText-string": "Algunos slots no se han añadido a ningún entrenamiento de la semana {{week}}. ¿Estás seguro/a de que deseas crear nuevas semanas?",
  "accessoriesNotAddedToWeekTitle-string": "NO HAY EJERCICIOS ACCESORIOS",
  "accessoriesNotAddedToWeekText-string": "No hay ejercicios accesorios en ningún entrenamiento de la semana {{week}}. ¿Estás seguro/a de que deseas crear una nueva semana sin accesorios?",
  "accessoriesNotAddedToWeekAllWeeksText-string": "No hay ejercicios accesorios en ningún entrenamiento de la semana {{week}}. ¿Estás seguro/a de que deseas crear nuevas semanas sin accesorios?",
  "conflictingExercisesTitle-string": "CONFLICTO DE SLOTS",
  "conflictingExerciseText-string": "Ya hay un ejercicio con este slot en esta semana: \n\n {{slot}}",
  "conflictingExercisesText-string": "Ya hay ejercicios con estos slots en esta semana: \n\n {{slots}}",
  "createFirstWeekWorkoutsTitle-string": "ELIMINAR ENTRENAMIENTOS DE LA SEMANA 1",
  "createFirstWeekWorkoutsText-string": "Ya existen entrenamientos en la primera semana de este bloque. ¿Estás seguro de que deseas eliminarlos y generar nuevos entrenamientos a partir del split?",
  "deleteBlockAlertTitle-string": "ELIMINAR BLOQUE DE ENTRENAMIENTO",
  "deleteBlockAlertText-string": "Escribe el nombre para eliminar el bloque",
  "deleteWeekAlertTitle-string": "ELIMINAR SEMANA",
  "deleteWeekAlertText-string": "¿Estás seguro/a de eliminar todos los entrenamientos de la semana {{week}}?",
  "deleteWeekWorkoutsTooltip-string": "Eliminar entrenamientos de la semana",
  "deleteExerciseAlertTitle-string": "ELIMINAR EJERCICIO",
  "deleteExerciseAlertText-string": "¿Estás seguro/a de eliminar el ejercicio '{{itemName}}'?",
  "deleteExerciseWarningAlertText-string": "Para eliminar '{{itemName}}', abre la sesión de entrenamiento correspondiente y elimínalo allí.",
  "deleteProtocolAlertTitle-string": "ELIMINAR EJERCICIO",
  "deleteProtocolAlertText-string": "¿Estás seguro/a de eliminar el ejercicio '{{itemName}}'?",
  "deleteProtocolFromWorkoutAlertText-string": "El ejercicio '{{itemName}}' está en el entrenamiento '{{workoutName}}'. ¿Estás seguro/a de eliminarlo?",
  "summaryOf-string": "Resumen de {{name}}",
  "session-string": "SESIÓN",
  "protocol-string": "Protocolo",
  "primary-string": "Primaria",
  "secondary-string": "Secundaria",
  "tertiary-string": "Terciaria",
  "quaternary-string": "Cuaternaria",
  "quinary-string": "Quinaria",
  "notesAboutBlock-string": "Notas sobre el bloque",
  "blockAverages-string": "Promedios del bloque",
  "averageStressIndex-string": "S.I. promedio",
  "averageTonnage-string": "Tonelaje promedio",
  "averageSets-string": "Series promedio",
  "averageNL-string": "NL promedio",
  "volumeAndStress-string": "Volumen y estrés",
  "primarySessions-string": "Sesiones primarias",
  "bestSet-string": "Mejor serie",
  "bestE1rm-string": "Mejor E1RM",
  "loadIncrease-string": "Salto de carga",
  "copyEntireBlock-string": "Copiar bloque entero",
  "copyWeek-string": "Copiar semana",
  "copyFullWeek-string": "Copiar semana completa",
  "copyTargetWeek-string": "Copiar el objetivo",
  "copyActualToTargetWeek-string": "Copiar real al objetivo",
  "actualToTarget-string": "Real a objetivo",
  "duplicateWeek-string": "Duplicar semana",
  "configureWeeks-string": "Configurar semanas",
  "duplicateWeekWithNumber-string": "Duplicar Semana {{week}}",
  "duplicateWeekSubtitle-string": "Copiando {{week}}",
  "duplicateWeekSelectFutureHint-string": "Elige las semanas donde duplicar esta semana:",
  "duplicateWeekCopyActualLabel-string": "Copiar los valores reales a los objetivos",
  "duplicateWeekCopyActualHelper-string": "Usa los valores reales de la semana {{week}} como objetivos en la semana seleccionada.",
  "duplicateWeekSingleWeekOnly-string": "Solo puedes seleccionar una semana para copiar los valores reales a los objetivos.",
  "duplicateWeekInfo-string": "Las progresiones de slots del Panel se aplicarán a las semanas duplicadas.",
  "duplicateWeekWarningMissingSlotSingular-string": "El slot {{slots}} no se ha añadido a ningun entrenamiento de la semana {{week}}.",
  "duplicateWeekWarningMissingSlotsPlural-string": "Los slots {{slots}} no se han añadido a ningun entrenamiento de la semana {{week}}.",
  "duplicateWeekWarningQuestion-string": "¿Seguro que quieres duplicar la semana {{week}}?",
  "duplicateWeekWarningNoAccessory-string": "Ningún entrenamiento tiene ejercicios accesorios.",
  "duplicateWeekBlockedWeekTooltip-string": "Esta semana ya tiene entrenamientos con ejercicios.",
  "duplicateWeekConfirm-string": "Duplicar",
  "duplicateWeekSuccessTitle-string": "Semana duplicada",
  "duplicateWeekSuccessSingular-string": "Semana {{sourceWeek}} duplicada a {{targetWeek}}",
  "duplicateWeekSuccessPlural-string": "Semana {{sourceWeek}} duplicada a {{count}} semanas",
  "duplicateWeekToastTitle-string": "Semana duplicada",
  "duplicateWeekToastDescription-string": "Se ha duplicado {{sourceWeek}} a {{targetWeeks}}.",
  "weekHiddenToastTitle-string": "Semana oculta",
  "weekHiddenToastDescription-string": "{{weekLabel}} ahora está oculta.",
  "weekShownToastTitle-string": "Semana visible",
  "weekShownToastDescription-string": "{{weekLabel}} ahora está visible.",
  "copyExercisesWeek-string": "Copiar ejercicios",
  "createPendingWeeks-string": "Crear semanas pendientes",
  "createNextWeek-string": "Crear siguiente semana",
  "createWeeksXtoY-string": "Crear semanas pendientes ({{x}}-{{y}})",
  "addToCalendar-string": "Añadir al calendario",
  "workoutsSelected-string": "entrenamientos seleccionados",
  "duplicateExerciseTitle-string": "Duplicar Ejercicio",
  "duplicateExerciseSelectWorkouts-string": "Selecciona los entrenamientos donde duplicar este ejercicio:",
  "duplicateExerciseInfo-string": "El ejercicio se duplicará con todas sus series y modificadores a los entrenamientos seleccionados.",
  "duplicateExerciseConfirm-string": "Duplicar",
  "duplicateExerciseConfirmCount-string": "Duplicar a {{count}} entrenamientos",
  "duplicateExerciseSuccessTitle-string": "Ejercicio duplicado",
  "duplicateExerciseSuccess-string": "{{exerciseName}} duplicado a {{count}} {{count, plural, one {entrenamiento} other {entrenamientos}}}",
  "duplicateExerciseToastTitle-string": "Ejercicio duplicado",
  "duplicateExerciseToastDescription-string": "Se ha añadido {{exerciseName}} a {{workouts}}.",
  "duplicateExerciseKeepOrder-string": "Mantener la misma posición en el entrenamiento",
  "duplicateExerciseKeepOrderHint-string": "El ejercicio se insertará en la posición #{{order}} en los entrenamientos destino",
  "duplicateExerciseAppendOrderHint-string": "El ejercicio se insertará al final de los entrenamientos destino",
  "duplicateExerciseProtocolSlotBlockedTitle-string": "Semanas bloqueadas para este protocolo",
  "duplicateExerciseProtocolSlotBlockedBody-string": "Las semanas {{weeks}} ya incluyen {{protocolSlot}}.",
  "duplicateExerciseProtocolSlotBlockedBodySingular-string": "La semana {{weeks}} ya incluye {{protocolSlot}}.",
  "duplicateExerciseSecondaryProtocolSlotBlockedBody-string": "{{protocolSlot}} #2 solo se puede copiar a entrenamientos que incluyan {{protocolSlot}} #1.",
  "duplicateExerciseProtocolSlotOnePerWeekTooltip-string": "Ya has seleccionado un entrenamiento para añadir este slot en esta semana.",
  "weekAbbr-string": "S{{week}}",
  "noWorkoutsInBlock-string": "No hay entrenamientos en este bloque",
  "exercise-string": "Ejercicio",
  "workoutWithNumber-string": "Entrenamiento #{{number}}",
  "allWorkouts-string": "Todos",
  "filterWorkouts-string": "Filtrar Entrenamientos",
  "onlySlots-string": "Solo slots",
  "hiddenExercisesCount-string_one": "+{{count}} ejercicio",
  "hiddenExercisesCount-string_other": "+{{count}} ejercicios",
  "showAll-string": "Mostrar todos",
  "showing-string": "Mostrando",
  "clipboard-string": "Portapapeles",
  "viewClipboard-string": "Ver portapapeles",
  "expandExercises-string": "Expandir ejercicios",
  "collapseExercises-string": "Contraer ejercicios",
  "emptyClipboard-string": "Portapapeles vacío",
  "clipboardOneExercise-string": "1 ejercicio copiado",
  "clipboardMultipleExercises-string": "{{count}} ejercicios copiados",
  "clearAll-string": "Borrar Todo",
  "libraryWorkout-string": "Librería",
  "slots-string": "Slots",
  "createFirstWeekOfWorkouts-string": "Generar la primera semana de entrenamientos a partir del split",
  "createFirstWeekOfWorkoutsButton-string": "Crear Entrenamientos Semana 1",
  "firstWeekOfWorkoutsCreated-string": "Ya hay entrenamientos con ejercicios en la semana 1",
  "linkExerciseToSlot-string": "VINCULAR EJERCICIO A SLOT",
  "alreadyOneExerciseForSlot-string": "Este slot ya contiene '{{exerciseName}}'. ¿Seguro que quieres añadir también este ejercicio?",
  "alreadyOneExerciseForSlotAnotherWorkout-string": "Este slot ya contiene '{{exerciseName}}'. Para añadir este ejercicio, ambos deben pertenecer al mismo entrenamiento.",
  "ThisSlotIsFull-string": "Este slot ya contiene '{{firstExerciseName}} + {{secondExerciseName}}'.",
  "unlinkExerciseFromSlotWarningTitle-string": "DESVINCULAR EJERCICIO DE SLOT",
  "unlinkExerciseFromSlotWarningText-string": "Estás seguro/a de desvincular el ejercicio '{{exerciseName}}' del slot '{{slotName}}'? El ejercicio no se borrará.",
  "unlinkExercisesFromSlotWarningText-string": "Estás seguro/a de desvincular los ejercicios '{{firstExerciseName}}' y '{{secondExerciseName}}' del slot '{{slotName}}'? Los ejercicios no se borrarán.",
  "exerciseLinkedToastTitle-string": "Ejercicio vinculado",
  "exerciseLinkedToastDescription-string": "Se ha vinculado {{exerciseName}} a {{slotName}}.",
  "exerciseUnlinkedToastTitle-string": "Ejercicio desvinculado",
  "exerciseUnlinkedToastDescription-string": "Se ha desvinculado {{exerciseName}} de {{slotName}}.",
  "addSlot-string": "Añade un Slot",
  "selectExerciseAndModifiers": "Selecciona un ejercicio y sus modificadores",
  "protocols-string": "Protocolos",
  "primarySquat-string": "Sentadilla Primaria",
  "secondarySquat-string": "Sentadilla Secundaria",
  "tertiarySquat-string": "Sentadilla Terciaria",
  "quaternarySquat-string": "Sentadilla Cuaternaria",
  "quinarySquat-string": "Sentadilla Quinaria",
  "primaryBenchPress-string": "Press Banca Primaria",
  "secondaryBenchPress-string": "Press Banca Secundaria",
  "tertiaryBenchPress-string": "Press Banca Terciaria",
  "quaternaryBenchPress-string": "Press Banca Cuaternaria",
  "quinaryBenchPress-string": "Press Banca Quinaria",
  "primaryDeadlift-string": "Peso Muerto Primario",
  "secondaryDeadlift-string": "Peso Muerto Secundario",
  "tertiaryDeadlift-string": "Peso Muerto Terciario",
  "quaternaryDeadlift-string": "Peso Muerto Cuaternario",
  "quinaryDeadlift-string": "Peso Muerto Quinario",
  "lift-string": "Ejercicio básico",
  "priority-string": "Prioridad",
  "setsDots-string": "Series:",
  "target-string": "OBJETIVO",
  "actual-string": "REAL",
  "actualExerciseCard-string": "REALIZADO",
  "weight-string": "PESO",
  "reps-string": "REPS",
  "dayWithNumber-string": "Día {{number}}",
  "rir-string": "RIR",
  "rpe-string": "RPE",
  "priorityHeader-string": "P",
  "showActual-string": "Mostrar Real",
  "hideActual-string": "Ocultar Real",
  "weekWithNumberAndDay-string": "Semana {{week}} - {{day}}",
  "linkSlotWithExercise-string": "Quieres vincular el slot '{{slotName}}' al ejercicio del entrenamiento ",
  "linkSlotSelectWorkouts-string": "Selecciona los entrenamientos que contienen el ejercicio '{{slotName}}' para vincular los ejercicios al slot",
  "linkSlotSameWorkout1-string": "Selecciona los ejercicios del entrenamiento ",
  "linkSlotSameWorkout2-string": " que deseas vincular al slot '{{slotName}}'",
  "notesDots-string": "Notas...",
  "primaryF-string": "Primaria",
  "secondaryF-string": "Secundaria",
  "tertiaryF-string": "Terciaria",
  "quaternaryF-string": "Cuaternaria",
  "quinaryF-string": "Quinaria",
  "primaryM-string": "Primario",
  "secondaryM-string": "Secundario",
  "tertiaryM-string": "Terciario",
  "quaternaryM-string": "Cuaternario",
  "quinaryM-string": "Quinario",
  "modifiers-string": "Modificadores",
  "history-string": "Historial",
  "seeMore-string": "Ver más",
  "emptyHistoryTitle-string": "Sin Historial",
  "emptyHistoryText-string": "No hay ejercicios en el historial",
  "selectExercisesTitle-string": "Selecciona Ejercicios",
  "selectExercisesText-string": "Selecciona ejercicios predefinidos o un entrenamiento de la librería",
  "selectExercises&SlotsText-string": "Selecciona slots del bloque, ejercicios predefinidos o un entrenamiento de la librería",
  "selectExercisesLibrary-string": "Selecciona ejercicios predefinidos",
  "exerciseProtocols-string": "Protocolos de {{name}}",
  "exerciseSlots-string": "Slots de {{name}}",
  "showPredefinedExercises-string": "Mostrar ejercicios predefinidos",
  "showWorkoutLibrary-string": "Mostrar librería de entrenamientos",
  "deleteWorkoutAlert-string": "\n¿Estás seguro/a de eliminar el entrenamiento?",
  "withoutDate-string": "Sin fecha",
  "moveUp-string": "Mover arriba",
  "moveDown-string": "Mover abajo",
  "copyToAnotherWeek-string": "Copiar a otra semana",
  "moveToAnotherWeek-string": "Mover a otra semana",
  "exportToLibrary-string": "Exportar a la librería",
  "exportPdf-string": "Exportar PDF",
  "moveToLibrary-string": "Mover a la librería",
  "exportWorkoutToLibraryDisabledTooltip-string": "Añade ejercicios para exportar el entrenamiento a tu librería",
  "emptyAttributesTitle-string": "Sin Modificadores",
  "noAttributesFoundText-string": "No se han encontrado modificadores",
  "emptyExercisesTitle-string": "Sin Ejercicios",
  "emptyExercisesText-string": "Añade ejercicios al entrenamiento",
  "noExercisesFoundText-string": "No se han encontrado ejercicios",
  "statisticsSearchPerformedExercisesPrompt-string": "Busca ejercicios realizados",
  "searchExercisePlaceholder-string": "Buscar ejercicio",
  "suggestedExercises-string": "Sugeridos",
  "exerciseNotInAllBlocks-string": "El ejercicio no está presente en todos los bloques seleccionados",
  "searchingEllipsis-string": "Buscando...",
  "addExercises-string": "Añadir ejercicios",
  "highPriority-string": "Prioridad alta",
  "mediumPriority-string": "Prioridad media",
  "lowPriority-string": "Prioridad baja",
  "nameOfBlockDots-string": "Nombre del bloque: ",
  "newWeekName-string": "Nuevo nombre de semana...",
  "showStats-string": "Mostrar Stats",
  "hideStats-string": "Ocultar Stats",
  "hideWeek-string": "Ocultar semana",
  "showWeek-string": "Mostrar semana",
  "editWeekName-string": "Editar nombre de semana",
  "linkExerciseToSlotTooltip-string": "Vincular ejercicio a slot",
  "unlinkExerciseFromSlotTooltip-string": "Desvincular ejercicio de slot",
  "requestVideo-string": "Solicitar vídeo",
  "dontRequestVideo-string": "No solicitar vídeo",
  "copyToNextSet-string": "Copiar a la siguiente serie",
  "deleteSet-string": "Eliminar serie",
  "copyTargetToActual-string": "Copiar objetivo a real",
  "setPriority-string": "Prioridad de la serie",
  "addSet-string": "Añadir serie",
  "copySets-string": "Copiar series",
  "pasteSets-string": "Pegar series",
  "exercisesCopied-string": "Ejercicios copiados",
  "exercisesCopiedDescription-string": "Ejercicios copiados de {{workoutName}}.",
  "exerciseCopied-string": "Ejercicio copiado",
  "exerciseCopiedDescription-string": "{{exerciseName}} copiado.",
  "setsCopied-string": "Series copiadas",
  "setsCopiedDescription-string": "Series copiadas de {{exerciseName}}.",
  "exercisesPasted-string": "Ejercicios pegados",
  "exercisesPastedDescription-string": "Ejercicios pegados en {{workoutName}}.",
  "setsPasted-string": "Series pegadas",
  "setsPastedDescription-string": "Series pegadas en {{exerciseName}}.",
  "editExercise-string": "Editar ejercicio",
  "copyExercise-string": "Copiar ejercicio",
  "move-string": "Mover",
  "editProtocol-string": "Editar protocolo",
  "addProtocolPlaceholder-string": "Añadir protocolo…",
  "unknownProtocolFormat-string": "Formato de protocolo desconocido: \"{{segment}}\"",
  "protocolError-string": "Error de protocolo",
  "editNote-string": "Editar nota",
  "editWorkout-string": "Editar entrenamiento",
  "editTargetWeight-string": "Editar peso objetivo",
  "editTargetReps-string": "Editar repeticiones objetivo",
  "editTargetRPE-string": "Editar RPE objetivo",
  "addVideoLink-string": "Añadir enlace de vídeo",
  "editVideoLink-string": "Editar enlace de vídeo",
  "slotExplanation-string": "Un slot es un ejercicio básico (sentadilla, press banca, peso muerto) o una variante de estos movimientos.",
  "resetCompletedAthletes-string": "Reiniciar atletas completados",
  "filterAthletes-string": "Filtrar atletas",
  "startAddingSlotsBeforeShowingActual-string": "Empieza a añadir slots para mostrar el real de las series",
  "showActualOfSets-string": "Muestra el real de las series",
  "hideActualOfSets-string": "Ocultar el real de las series",
  "copyWeekSlotsAndProtocols-string": "Copiar slots y protocolos de la semana",
  "copySlotAndProtocol-string": "Copiar slot y protocolo",
  "protocolsGuide-string": "Guía de Protocolos",
  "protocolsGuideDescription-string": "Crea series escribiendo cualquiera de los siguientes formatos:",
  "protocolsFixedRepsRPE-string": "Reps y RPE Fijos",
  "protocolsFixedWeightReps-string": "Peso y Reps Fijos",
  "protocolsCombineWith-string": "Combina protocolos con el símbolo",
  "protocolsCombineSymbol-string": "+",
  "protocolsCombineExample-string": "ej. \"x4 @7 + 2x4 @5\"",
  "startAddingSlotsBelow-string": "Empieza añadiendo slots debajo",
  "protocolMoveWeekLimit-string": "Los slots deben mantenerse en la misma semana",
  "protocolMoveWeekLimitDescription-string": "Los ejercicios vinculados a slots no pueden moverse a otras semanas",
  "protocolMovePackToast-string": "Tambien se movió {{pairedName}}",
  "exerciseMovedToastTitle-string": "Ejercicio movido",
  "exerciseMovedToastTitlePlural-string": "Ejercicios movidos",
  "exerciseMovedToastDescriptionSameWorkout-string": "Se ha movido {{exerciseName}} a #{{position}}.",
  "exerciseMovedToastDescriptionSameWeek-string": "Se ha movido {{exerciseName}} a {{workoutName}} (#{{position}}).",
  "exerciseMovedToastDescriptionCrossWeek-string": "Moviendo {{exerciseName}} a {{workoutName}} · {{weekLabel}} (#{{position}}).",
  "exerciseMovedToastDescriptionPluralSameWorkout-string": "Se han movido {{firstExerciseName}} y {{secondExerciseName}} a #{{firstPosition}}, #{{secondPosition}}.",
  "exerciseMovedToastDescriptionPluralSameWeek-string": "Se han movido {{firstExerciseName}} y {{secondExerciseName}} a {{workoutName}} (#{{firstPosition}}, #{{secondPosition}}).",
  "exerciseMovedToastDescriptionPluralCrossWeek-string": "Se han movido {{firstExerciseName}} y {{secondExerciseName}} a {{workoutName}} · {{weekLabel}} (#{{firstPosition}}, #{{secondPosition}}).",
  "maxExercisesPerWorkoutReached-string": "Límite de ejercicios alcanzado",
  "maxExercisesPerWorkoutDescription-string": "Puedes tener hasta {{limit}} ejercicios por entrenamiento.",
  "maxSetsPerExerciseReached-string": "Límite de series alcanzado",
  "maxSetsPerExerciseDescription-string": "Puedes tener hasta {{limit}} series por ejercicio.",
  "maxWorkoutsPerWeekReached-string": "Límite de entrenamientos alcanzado",
  "maxWorkoutsPerWeekDescription-string": "Puedes tener hasta {{limit}} entrenamientos por semana.",
  "nutrition-string": "Nutrición",
  "nutritionPlanTotalsDefaultForNewClients-string": "Mostrar calorías y macros por defecto",
  "nutritionPlanTotalsDefaultForNewClientsTooltip-string": "Luego puedes decidir para cada atleta si mostrarlo u ocultarlo desde el perfil del atleta.",
  "nutritionPlanTotalsVisibility-string": "Mostrar calorías y macros",
  "nutritionPlanTotalsUseCoachDefault-string": "Usar valor por defecto del entrenador",
  "nutritionPlanTotalsShowTotals-string": "Mostrar",
  "nutritionPlanTotalsHideTotals-string": "Ocultar",
  "beta-string": "Beta",
  "nutritionPlanName-string": "Nombre del plan nutricional",
  "nutritionPlanNotes-string": "Descripción",
  "newNutritionPlanName-string": "Nuevo Plan Nutricional...",
  "newNutritionPlanNotes-string": "Añade una descripción al plan nutricional...",
  "meals-string": "Comidas",
  "recipes-string": "Recetas",
  "mealsDistribution-string": "Distribución de comidas",
  "deleteMeal-string": "Eliminar Comida",
  "nutritionPlanAddNote-string": "Añadir nota",
  "nutritionPlanDeleteMeal-string": "Eliminar comida",
  "mealNotes-string": "Añade una descripción a la comida...",
  "addMeal-string": "Añadir Comida",
  "addFoodOptions-string": "Añadir opciones de comida",
  "addOption-string": "Añadir opción",
  "addFood-string": "Añadir alimentos",
  "addCustomFood-string": "Añadir nuevo alimento",
  "copyNutritionPlan-string": "Copiar Plan Nutricional",
  "foodOption-string": "Opción {{optionNumber}}",
  "goal-string": "Objetivo",
  "setMacroGoals-string": "Determina Objetivos de Macros",
  "byGrams-string": "Por gramos",
  "byPercentages-string": "Por porcentajes",
  "current-string": "Actual",
  "createNutritionPlan-string": "Crear plan nutricional",
  "editNutritionPlan-string": "Editar plan nutricional",
  "nutritionPlanNotesPlaceholder-string": "Añade notas o indicaciones opcionales para este plan",
  "nutritionPlanNamePlaceholder-string": "Día de entrenamiento - alto en carbohidratos",
  "nutritionPlanObjectivesTitle-string": "Objetivos",
  "nutritionPlanObjectivesPercentModeHint-string": "Define las calorías y después arrastra los deslizadores para fijar los porcentajes deseados.",
  "nutritionPlanObjectivesGramModeHint-string": "Define los gramos de proteína, carbohidratos y grasas. Las calorías totales se calculan automáticamente a partir de esos valores.",
  "nutritionPlanGoalsByPercentage-string": "Por %",
  "nutritionPlanGoalsByGrams-string": "Por g",
  "nutritionPlanEditGoals-string": "Editar objetivos",
  "nutritionPlanMacroSplitLabel-string": "Reparto de macros",
  "nutritionPlanEnergyRemaining-string": "{{value}} kcal restantes",
  "nutritionPlanEnergyExceeded-string": "{{value}} kcal excedidas",
  "nutritionPlanAddMeal-string": "Añadir comida",
  "nutritionPlanAddAlternativeOption-string": "Añadir opción alternativa",
  "nutritionPlanAddOptionInline-string": "Añadir opción",
  "nutritionPlanReorderOptionA11y-string": "Reordenar opción",
  "nutritionPlanExpandMealA11y-string": "Expandir comida",
  "nutritionPlanCollapseMealA11y-string": "Contraer comida",
  "nutritionPlanMealsEmptyTitle-string": "Todavía no hay comidas",
  "nutritionPlanMealsEmptyDescription-string": "Crea la primera comida para empezar a componer el plan.",
  "nutritionPlanDropFoodHere-string": "Suelta el alimento aquí",
  "nutritionPlanDeleteMealAlertText-string": "Esta comida contiene alimentos en una o más opciones. ¿Seguro que quieres eliminarla?",
  "nutritionPlanMealName-string": "Nombre de la comida",
  "nutritionPlanOptionName-string": "Nombre de la opción",
  "nutritionPlanAddPickerSubtitle-string": "Busca alimentos, equivalencias y recetas y añádelos a esta opción.",
  "nutritionPlanSaveConflictTitle-string": "Este plan cambió en otro lugar",
  "nutritionPlanSaveErrorMessage-string": "No hemos podido guardar este plan nutricional. Inténtalo de nuevo.",
  "nutritionPlanAutosaveConflictMessage-string": "Hemos rebasado los campos no tocados sobre la última revisión del plan y volveremos a intentar guardar tus cambios locales.",
  "nutritionPlanMealNameSearch-string": "Busca o escribe un nombre de comida",
  "nutritionPlanMealNameSuggestions-string": "Nombres de comida",
  "nutritionPlanMealNameEmpty-string": "No hay nombres de comida que coincidan",
  "nutritionPlanMealNameUseCustom-string": "Usar \"{{value}}\"",
  "nutritionLimitReachedTitle-string": "Límite alcanzado",
  "nutritionLimitReachedDescription-string": "Este borrador de nutrición es demasiado grande para guardarlo con seguridad.",
  "nutritionEquivalentFoodsLimitDescription-string": "Puedes añadir hasta {{limit}} alimentos a una equivalencia.",
  "nutritionRecipeFoodsLimitDescription-string": "Puedes añadir hasta {{limit}} alimentos a una receta.",
  "nutritionMealFoodsLimitDescription-string": "Puedes añadir hasta {{limit}} alimentos totales a una comida.",
  "nutritionPlanMealsLimitDescription-string": "Puedes añadir hasta {{limit}} comidas a un plan nutricional.",
  "nutritionMealOptionsLimitDescription-string": "Puedes añadir hasta {{limit}} opciones a una comida.",
  "nutritionNameTooLongLimitDescription-string": "Los nombres pueden tener hasta {{limit}} caracteres.",
  "nutritionRecipeDescriptionTooLongLimitDescription-string": "Las descripciones de recetas pueden tener hasta {{limit}} caracteres.",
  "nutritionPlanNotesTooLongLimitDescription-string": "Las notas del plan pueden tener hasta {{limit}} caracteres.",
  "nutritionMealNotesTooLongLimitDescription-string": "Las notas de la comida pueden tener hasta {{limit}} caracteres.",
  "breakfast-string": "Desayuno",
  "main-string": "Principal",
  "lunch-string": "Comida",
  "dinner-string": "Cena",
  "snack-string": "Snack",
  "recipeType-string": "Tipo de receta",
  "addNewIngredient-string": "Añadir nuevo alimento",
  "recipeAddPickerSubtitle-string": "Busca alimentos y equivalencias y añádelos a esta receta.",
  "addEquivalent-string": "Añadir equivalencia",
  "addFoodEquivalent-string": "Añadir alimento equivalente",
  "equivalentAddFirstFood-string": "Añadir primer alimento",
  "addAnotherOption-string": "Añadir otra opción",
  "addingEquivalentTo-string": "Añadiendo equivalencia a {{name}}",
  "nutritionAutoCalculatedEquivalentTooltip-string": "Calculado automáticamente para igualar las calorías",
  "searchFood-string": "Buscar alimento",
  "searchFoodOrEquivalent-string": "Buscar alimento o equivalencia",
  "searchFoodEquivalentRecipe-string": "Buscar alimento, equivalencia o receta",
  "allDatabases-string": "Todas las bases de datos",
  "noPickerResults-string": "No hay resultados para esta búsqueda",
  "equivalentResultType-string": "Equivalencia",
  "recipeResultType-string": "Receta",
  "recipeNamePlaceholder-string": "Espaguetis a la boloñesa",
  "equivalentNamePlaceholder-string": "Fuentes de carbohidratos",
  "createRecipe-string": "Crear receta",
  "createEquivalent-string": "Crear equivalencia",
  "editRecipe-string": "Editar receta",
  "editEquivalent-string": "Editar equivalencia",
  "autosaveOfflinePending-string": "Pendiente sin conexión",
  "autosaveError-string": "No se pudo guardar",
  "nutritionDeletedRemotelyTitle-string": "Eliminado en otro lugar",
  "nutritionDeletedRemotelyMessage-string": "Este elemento se eliminó en otro sitio. Si guardas tus cambios, se restaurará. Si los descartas, desaparecerá de aquí.",
  "nutritionEditorRetryNotice-string": "No pudimos guardar los últimos cambios. Intenta guardar de nuevo.",
  "nutritionFoodOfflinePendingNotice-string": "Este cambio está pendiente por falta de conexión. Se sincronizará cuando vuelva la conexión.",
  "nutritionFoodSaveErrorNotice-string": "No pudimos guardar este alimento. Intenta guardarlo de nuevo.",
  "nutritionFoodOfflinePendingToast-string": "Este alimento se sincronizará cuando vuelva la conexión.",
  "nutritionFoodSaveErrorToastDescription-string": "No pudimos guardar este alimento. Vuelve a abrirlo e inténtalo de nuevo.",
  "equivalentEmptySwapTitle-string": "Todavía no hay nada que intercambiar",
  "equivalentEmptySwapBody-string": "Añade al menos dos alimentos para crear una equivalencia.",
  "emptyRecipeFunnyTitle-string": "La estación ya está lista",
  "emptyRecipeFunnySubtitle-string": "Ahora solo faltan ingredientes de verdad. Añade alimentos para construir la receta.",
  "noIngredientResults-string": "No hay alimentos para esta búsqueda",
  "replaceLegacyIngredientsBeforeSavingRecipe-string": "Sustituye los alimentos sin resolver antes de guardar la receta.",
  "ingredientQuantityRequired-string": "Cada alimento necesita una cantidad mayor que 0",
  "equivalentOptionUnsaveableTitle-string": "Esta opción no se puede guardar",
  "equivalentOptionUnsaveableDescription-string": "Esta fuente de alimento todavía no se puede guardar en equivalencias. Elimínala o elige otro alimento.",
  "recipeDerivedFromFoodsTooltip-string": "Importado de los alimentos añadidos a esta receta.",
  "nutritionConflictReasonContains-string": "Contiene {{item}}",
  "nutritionConflictReasonNotVegetarian-string": "No vegetariano",
  "nutritionConflictReasonNotVegan-string": "No vegano",
  "calories-string": "Calorías",
  "energy-string": "Energía",
  "carbs-string": "Carbs",
  "carbohydrates-string": "Carbohidratos",
  "protein-string": "Proteína",
  "fats-string": "Grasas",
  "fiber-string": "Fibra",
  "per100g-string": "Valor nutricional por 100g",
  "per100gShort-string": "por 100g",
  "commonMeasures-string": "Medidas caseras",
  "website-string": "Página web",
  "sugars-string": "Azúcares",
  "transFat-string": "Grasa trans",
  "water-string": "Agua",
  "alcohol-string": "Alcohol",
  "sodium-string": "Sodio",
  "potassium-string": "Potasio",
  "calcium-string": "Calcio",
  "phosphorus-string": "Fosforo",
  "iron-string": "Hierro",
  "magnesium-string": "Magnesio",
  "zinc-string": "Zinc",
  "copper-string": "Cobre",
  "manganese-string": "Manganeso",
  "selenium-string": "Selenio",
  "iodine-string": "Yodo",
  "vitaminA-string": "Vitamina A",
  "vitaminB1-string": "Vitamina B1",
  "vitaminB2-string": "Vitamina B2",
  "vitaminB3-string": "Vitamina B3",
  "vitaminB5-string": "Vitamina B5",
  "vitaminB6-string": "Vitamina B6",
  "vitaminB7-string": "Vitamina B7",
  "vitaminB9-string": "Vitamina B9",
  "vitaminC-string": "Vitamina C",
  "vitaminD-string": "Vitamina D",
  "vitaminB12-string": "Vitamina B12",
  "vitaminE-string": "Vitamina E",
  "vitaminK-string": "Vitamina K",
  "caffeine-string": "Cafeina",
  "monounsaturatedFat-string": "Grasa monoinsaturada",
  "polyunsaturatedFat-string": "Grasa poliinsaturada",
  "saturatedFat-string": "Grasa saturada",
  "omega3-string": "Omega-3",
  "cholesterol-string": "Colesterol",
  "leucine-string": "Leucina",
  "newPlan-string": "Nuevo Plan",
  "newNutritionPlanCta-string": "Nuevo plan nutricional",
  "numberOfMeals-string": "{{number}} comidas",
  "food-string": "Alimento",
  "foods-string": "Alimentos",
  "searchByName-string": "Buscar por nombre",
  "supplement-string": "Suplemento",
  "createdByMe-string": "Creados por mí",
  "catalogSourceEfort-string": "EFORT",
  "catalogSourceFoodDatabase-string": "Base de datos de alimentos",
  "catalogSourceOpenSource-string": "OPEN SOURCE",
  "nutritionPlans-string": "Planes Nutricionales",
  "equivalents-string": "Equivalencias",
  "noEquivalentsFound-string": "No se han encontrado equivalencias",
  "equivalentLibraryEmptyTitle-string": "Tu librería de equivalencias está vacía",
  "equivalentLibraryEmptyDescription-string": "Crea tu primera equivalencia para intercambiar alimentos con valores nutricionales similares.",
  "newFood-string": "Nuevo Alimento",
  "foodLibraryEmptyTitle-string": "Tu librería de alimentos está vacía",
  "foodLibraryEmptyDescription-string": "Crea tu primer alimento para empezar a construir comidas y planes nutricionales.",
  "noFoodsFound-string": "No se han encontrado alimentos",
  "recipeLibraryEmptyTitle-string": "Tu librería de recetas está vacía",
  "recipeLibraryEmptyDescription-string": "Crea tu primera receta para empezar a reutilizar combinaciones de ingredientes en tus planes.",
  "noRecipesFound-string": "No se han encontrado recetas",
  "nutritionPlanLibraryEmptyTitle-string": "Tu librería de planes nutricionales está vacía",
  "nutritionPlanLibraryEmptyDescription-string": "Crea tu primer plan nutricional para empezar a organizar estructuras de comidas reutilizables.",
  "noNutritionPlansFound-string": "No se han encontrado planes nutricionales",
  "nutritionPlanAssignAction-string": "Asignar",
  "nutritionPlanAssignmentsSubtitle-string": "Selecciona a qué atletas asignar este plan nutricional.",
  "nutritionPlanAssignmentsAthletePlansTitle-string": "Planes de {{name}}",
  "nutritionPlanAssignmentsAthletesTitle-string": "Selecciona atletas",
  "nutritionPlanAssignmentsSearchPlaceholder-string": "Buscar atletas",
  "nutritionPlanAssignmentsSelectedAthletes-string": "Seleccionados",
  "nutritionPlanAssignmentsNoAthleteSelectedTitle-string": "Selecciona un atleta",
  "nutritionPlanAssignmentsNoAthleteSelectedDescription-string": "Elige atletas a la izquierda y después selecciona uno aquí para revisar el estado actual de sus planes.",
  "nutritionPlanAssignmentsLoadErrorTitle-string": "Error al cargar los planes asignados",
  "nutritionPlanAssignmentsLoadErrorDescription-string": "No hemos podido cargar los planes nutricionales actuales de este atleta. Inténtalo de nuevo.",
  "nutritionPlanAssignmentsLoadErrorInlineTitle-string": "No se pudieron cargar los planes",
  "nutritionPlanAssignmentsLoadErrorInlineDescription-string": "Prueba con otro atleta o cierra y vuelve a abrir la vista.",
  "nutritionPlanAssignmentsActiveLabel-string": "Activos",
  "nutritionPlanAssignmentsLastArchivedSection-string": "• Últimos archivados",
  "nutritionPlanAssignmentsArchiveAction-string": "Archivar",
  "nutritionPlanAssignmentsArchiveTooltip-string": "Archivar plan",
  "nutritionPlanAssignmentsRestoreTooltip-string": "Restaurar plan",
  "nutritionPlanAssignmentsSaveChanges-string": "Guardar cambios",
  "nutritionPlanAssignmentsSaveCompact-string": "Guardar",
  "nutritionPlanAssignmentsNoActivePlans-string": "No hay planes nutricionales activos para este atleta.",
  "nutritionPlanAssignmentsNoArchivedPlans-string": "No hay planes nutricionales archivados para este atleta.",
  "nutritionPlanAssignmentsNewBadge-string": "NUEVO",
  "nutritionPlanAssignmentsReviewSelectedCompact-string": "Revisar ({{count}})",
  "nutritionPlanAssignmentsNoAthletesFound-string": "Ningún atleta coincide con la búsqueda actual.",
  "nutritionPlanAssignmentConflictsTitle-string": "Conflictos encontrados",
  "nutritionPlanAssignmentAcceptAction-string": "Aceptar asignación",
  "nutritionPlanAssignmentRemoveAction-string": "Eliminar asignación",
  "nutritionConflictWarningToastTitle-string": "Advertencia de conflicto",
  "nutritionConflictWarningToastDescription-string": "Este elemento entra en conflicto con la configuración nutricional del atleta.",
  "nutritionPlanUpdatedDate-string": "Actualizado {{date}}",
  "clientNutritionPlanFoldersActiveDescription-string": "Los planes activos serán visibles para el atleta.",
  "clientNutritionPlanFoldersArchivedDescription-string": "Los planes archivados no serán visibles para el atleta.",
  "clientNutritionPlanFoldersCreateTooltip-string": "Crear plan nutricional",
  "clientNutritionPlanFoldersCreateArchivedTooltip-string": "Crear plan nutricional archivado",
  "clientNutritionPlanFoldersExportPdfTooltip-string": "Exportar planes activos como PDF",
  "clientNutritionPlanFoldersNoActive-string": "Todavía no hay planes nutricionales activos.",
  "clientNutritionPlanFoldersNoArchived-string": "Todavía no hay planes nutricionales archivados.",
  "clientNutritionPlanVisibleChip-string": "Visible para el atleta",
  "clientNutritionPlanHiddenChip-string": "Oculto para el atleta",
  "clientNutritionImportSearchPlaceholder-string": "Buscar planes nutricionales...",
  "clientNutritionImportLoadingTitle-string": "Cargando planes nutricionales de la librería",
  "clientNutritionImportEmptyLibraryDescription-string": "Crea un plan nutricional en la librería y aparecerá aquí.",
  "duplicate-string": "Duplicar",
  "nutritionPlanMealsLoading-string": "Cargando comidas...",
  "nutritionPlanPdfNoActivePlansTitle-string": "No hay planes activos",
  "nutritionPlanPdfNoActivePlansDescription-string": "No hay planes nutricionales activos para exportar.",
  "nutritionPlanPdfExportedTitle-string": "PDF exportado",
  "nutritionPlanPdfExportedDescription-string": "Se ha descargado \"{{name}}\".",
  "nutritionPlanPdfExportErrorTitle-string": "No se ha podido exportar el PDF",
  "nutritionPlanPdfExportErrorDescription-string": "Vuelve a intentarlo en un momento.",
  "nutritionCommonTryAgainLater-string": "Vuelve a intentarlo en un momento.",
  "nutritionAthleteFallback-string": "atleta",
  "nutritionPlanDeleteSuccessTitle-string": "Plan nutricional eliminado",
  "nutritionPlanDeleteSuccessDescription-string": "Se ha eliminado \"{{name}}\".",
  "nutritionPlanDeleteErrorTitle-string": "No se pudo eliminar el plan nutricional",
  "nutritionPlanDeleteConfirmationTitle-string": "ELIMINAR PLAN NUTRICIONAL",
  "nutritionPlanDeleteConfirmationDescription-string": "Este plan nutricional se eliminará permanentemente. Esta acción no se puede deshacer.",
  "nutritionPlanDeleteConfirmationInstruction-string": "Escribe \"{{value}}\" para confirmar.",
  "nutritionPlanDeleteConfirmationPlaceholder-string": "Escribe el nombre del plan nutricional",
  "nutritionPlanWorkspaceTransitionTitle-string": "Moviendo plan",
  "nutritionPlanWorkspaceTransitionDescription-string": "Moviendo plan nutricional al espacio de trabajo del atleta...",
  "nutritionPlanWorkspaceTransitionErrorTitle-string": "No se pudo mover el plan",
  "nutritionPlanWorkspaceTransitionErrorDescription-string": "No se pudo terminar de mover este plan al espacio de trabajo del atleta. Prueba a reabrir la vista de nutrición del atleta.",
  "nutritionPlanMacroDistributionChartA11y-string": "Gráfico de distribución de macros",
  "nutritionPlanMacroGramsInputA11y-string": "{{label}} gramos",
  "nutritionPlanActionIncompleteFallback-string": "Este plan nutricional todavía no está completamente cargado, así que no se pudo completar la acción.",
  "nutritionPlanActionIncompleteSingle-string": "\"{{name}}\" todavía no está completamente cargado, así que no se pudo completar la acción.",
  "nutritionPlanActionIncompleteMultiple-string": "Estos planes nutricionales todavía no están completamente cargados, así que no se pudo completar la acción: {{planNames}}.",
  "clientNutritionEmptyTitle-string": "Planes nutricionales del atleta",
  "clientNutritionEmptyDescription-string": "Aquí aparecerán los planes nutricionales del atleta.",
  "clientNutritionWorkspaceTitle-string": "Nutrición del atleta",
  "clientNutritionWorkspaceDescription-string": "Aquí aparecerá el nuevo espacio de nutrición del atleta.",
  "clientNutritionPlanImportSuccessTitle-string": "Plan nutricional importado",
  "clientNutritionPlanImportActiveSuccessDescription-string": "El plan se ha añadido a los planes activos.",
  "clientNutritionPlanImportArchivedSuccessDescription-string": "El plan se ha añadido a los planes archivados.",
  "clientNutritionPlanImportErrorTitle-string": "No se pudo importar el plan nutricional",
  "clientNutritionPlanCopySuccessTitle-string": "Plan nutricional copiado",
  "clientNutritionPlanCopySuccessDescription-string": "Se ha copiado \"{{planName}}\" a {{athleteName}}.",
  "clientNutritionPlanCopyErrorTitle-string": "No se pudo copiar el plan nutricional",
  "clientNutritionPlanCopyToAthleteEyebrow-string": "Copiar a atleta",
  "clientNutritionPlanCopyNoAthletesTitle-string": "No hay atletas disponibles",
  "clientNutritionPlanCopyNoAthletesDescription-string": "Añade otro atleta para copiar este plan nutricional.",
  "clientNutritionPlanExportSuccessTitle-string": "Plan nutricional exportado",
  "clientNutritionPlanExportSuccessDescription-string": "Se ha guardado en la librería como \"{{name}}\".",
  "clientNutritionPlanExportErrorTitle-string": "No se pudo exportar el plan nutricional",
  "clientNutritionPlanDuplicateSuccessTitle-string": "Plan nutricional duplicado",
  "clientNutritionPlanDuplicateSuccessDescription-string": "Se ha creado \"{{name}}\".",
  "clientNutritionPlanDuplicateErrorTitle-string": "No se pudo duplicar el plan nutricional",
  "nutritionPlanAssignmentsResolveConflictsTitle-string": "Resuelve los conflictos de nutrición antes de asignar",
  "nutritionPlanAssignmentsResolveConflictsSingleDescription-string": "Revisa la advertencia del atleta seleccionado y acepta o elimina la asignación.",
  "nutritionPlanAssignmentsResolveConflictsMultipleDescription-string": "Revisa la advertencia de cada atleta seleccionado y acepta o elimina la asignación.",
  "nutritionPlanAssignmentsSaveSuccessTitle-string": "Cambios de nutrición guardados",
  "nutritionPlanAssignmentsSaveSuccessDescription-string": "Las nuevas asignaciones y los cambios de estado del plan se han guardado correctamente.",
  "nutritionPlanAssignmentsSavePartialTitle-string": "No se pudieron guardar algunos cambios",
  "nutritionPlanAssignmentsSavePartialDescription-string": "Se han guardado {{successCount}} actualizaciones de atletas y {{failureCount}} han fallado.",
  "nutritionPlanAssignmentsSavePartialDescriptionWithError-string": "Se han guardado {{successCount}} actualizaciones de atletas y {{failureCount}} han fallado. {{errorDescription}}",
  "nutritionPlanAssignmentsSaveErrorTitle-string": "No se pudieron guardar los cambios",
  "archived-string": "Archivado",
  "adjustFiltersOrSearch-string": "Prueba a ajustar la búsqueda o cambiar los filtros activos.",
  "createFood-string": "Crea un nuevo alimento",
  "editFood-string": "Edita un alimento",
  "catalogFoodModalTitle-string": "Editar alimento",
  "duplicateAndSave-string": "Duplicar y guardar",
  "addFoodModalTitle-string": "Crea un nuevo alimento",
  "addFoodModalNameLabel-string": "Nombre",
  "addFoodModalNamePlaceholder-string": "Pechuga de pollo",
  "addFoodModalTypeLabel-string": "Tipo",
  "addFoodModalMeasuresDescription-string": "ej., 1 pieza = 20 g.",
  "addFoodModalMeasurePlaceholder-string": "Añadir una medida casera",
  "addFoodModalMeasureSearch-string": "Buscar una medida",
  "addFoodModalNoMeasuresFound-string": "No hay medidas que coincidan",
  "addFoodModalMicrosTitle-string": "Micronutrientes",
  "addFoodModalWebsiteDescription-string": "Enlace de referencia opcional para el producto original.",
  "addFoodModalWebsitePlaceholder-string": "https://...",
  "nutritionFoodUpdatedTitle-string": "Alimento actualizado",
  "nutritionFoodUpdatedDescription-string": "Se ha actualizado \"{{name}}\".",
  "nutritionFoodCreatedTitle-string": "Alimento creado",
  "nutritionFoodCreatedDescription-string": "Se ha creado \"{{name}}\".",
  "nutritionFoodDeleteSuccessTitle-string": "Alimento eliminado",
  "nutritionFoodDeleteSuccessDescription-string": "Se ha eliminado \"{{name}}\".",
  "nutritionFoodDeleteErrorTitle-string": "No se pudo eliminar el alimento",
  "nutritionRecipeDeleteSuccessTitle-string": "Receta eliminada",
  "nutritionRecipeDeleteSuccessDescription-string": "Se ha eliminado \"{{name}}\".",
  "nutritionRecipeDeleteErrorTitle-string": "No se pudo eliminar la receta",
  "nutritionEquivalentDeleteSuccessTitle-string": "Equivalencia eliminada",
  "nutritionEquivalentDeleteSuccessDescription-string": "Se ha eliminado \"{{name}}\".",
  "nutritionEquivalentDeleteErrorTitle-string": "No se pudo eliminar la equivalencia",
  "quantityDots-string": "Cantidad:",
  "caloriesDots-string": "Calorías:",
  "carbsDots-string": "Carbs:",
  "carbohydratesDots-string": "Carbohidratos:",
  "proteinDots-string": "Proteína:",
  "fatsDots-string": "Grasas:",
  "foodBrand-string": "Marca...",
  "foodStore-string": "Tienda...",
  "measureMl-string": "mL",
  "measureMlPlural-string": "mL",
  "measureOz-string": "oz",
  "measureOzPlural-string": "oz",
  "measureFlOz-string": "fl oz",
  "measureFlOzPlural-string": "fl oz",
  "measureServing-string": "Ración",
  "measureServingPlural-string": "Raciones",
  "measureScoop-string": "Scoop",
  "measureScoopPlural-string": "Scoops",
  "measurePiece-string": "Pieza",
  "measurePiecePlural-string": "Piezas",
  "measureUnit-string": "Unidad",
  "measureUnitPlural-string": "Unidades",
  "measureSlice-string": "Rebanada",
  "measureSlicePlural-string": "Rebanadas",
  "measureCup-string": "Taza",
  "measureCupPlural-string": "Tazas",
  "measureGlass-string": "Vaso",
  "measureGlassPlural-string": "Vasos",
  "measureTbsp-string": "Cucharada",
  "measureTbspPlural-string": "Cucharadas",
  "measureTsp-string": "Cucharadita",
  "measureTspPlural-string": "Cucharaditas",
  "measureSmall-string": "Pequeño",
  "measureSmallPlural-string": "Pequeños",
  "measureMedium-string": "Mediano",
  "measureMediumPlural-string": "Medianos",
  "measureLarge-string": "Grande",
  "measureLargePlural-string": "Grandes",
  "measureBottle-string": "Botella",
  "measureBottlePlural-string": "Botellas",
  "measureCan-string": "Lata",
  "measureCanPlural-string": "Latas",
  "quantity-string": "Cantidad",
  "addEquivalences-string": "Añadir Equivalencias",
  "customFoods-string": "Alimentos Personalizados",
  "searchFoods-string": "Buscar alimentos...",
  "clientHistoryFoodsDots-string": "Últimos alimentos usados del atleta:",
  "deleteCoachFoodAlertTitle-string": "ELIMINAR ALIMENTO",
  "deleteCoachFoodAlertText-string": "¿Estás seguro/a de eliminar el alimento de la librería?",
  "deleteNutritionPlanAlertTitle-string": "ELIMINAR PLAN",
  "deleteNutritionPlanAlertText-string": "¿Estás seguro/a de eliminar el plan nutricional?",
  "deletePendingNutritionPlanAlertTitle-string": "ELIMINAR PLAN",
  "deletePendingNutritionPlanAlertText-string": "¿Estás seguro/a de eliminar '{{itemName}}' de atletas invitados?",
  "TITOL ADD PREDEFINEDS": "",
  "newPredefinedExercise-string": "Nuevo Ejercicio Predefinido",
  "exerciseNamePlaceholder-string": "Nombre del ejercicio...",
  "editPredefinedExercise-string": "Edita el ejercicio predefinido",
  "addPredefinedExercise-string": "Crea un nuevo ejercicio predefinido",
  "typeDots-string": "Tipo: ",
  "newPredefinedAttribute-string": "Nuevo Modificador",
  "modifierNamePlaceholder-string": "Nombre del modificador...",
  "editPredefinedAttribute-string": "Edita el modificador predefinido",
  "addPredefinedAttribute-string": "Crea un nuevo modificador predefinido",
  "titleDots-string": "Título: ",
  "subtitleDots-string": "Subtítulo: ",
  "TITOL TIPUS DE MODIFICADORS": "",
  "equipment-string": "Equipamiento",
  "tempo-string": "Tempo",
  "rom-string": "Rango de Movimiento",
  "stanceGrip-string": "Posición/Agarre",
  "loadAccomodation-string": "Ajustes de Carga",
  "accessories-string": "Accesorios",
  "other-string": "Otros",
  "boards-string": "Tablas",
  "grip-string": "Agarre",
  "stance-string": "Posición",
  "bands-string": "Bandas",
  "reverseBands-string": "Bandas Inversas",
  "TITOL TIPUS DE EXERCICIS": "",
  "kneeDominant-string": "Dominante de Rodilla",
  "hipDominant-string": "Dominante de Cadera",
  "horizontalPush-string": "Empuje Horizontal",
  "verticalPush-string": "Empuje Vertical",
  "horizontalPull-string": "Tracción Horizontal",
  "verticalPull-string": "Tracción Vertical",
  "weightlifting-string": "Halterofilia",
  "TITOL LLISTA EXERCICIS": "",
  "squat-string": "Sentadilla",
  "hackSquat-string": "Sentadilla Hack",
  "bulgarianSplitSquat-string": "Sentadilla Búlgara",
  "splitSquat-string": "Lunge Estático",
  "frontSquat-string": "Sentadilla Frontal",
  "platzSquat-string": "Sentadilla Platz",
  "zercherSquat-string": "Sentadilla Zercher",
  "legCurls-string": "Curl de Piernas",
  "legExtension-string": "Extensión de Piernas",
  "legPress-string": "Prensa de Piernas",
  "beltSquat-string": "Sentadilla con Cinturón",
  "lunges-string": "Zancadas",
  "deadlift-string": "Peso Muerto",
  "conventionalDeadlift-string": "Peso Muerto Convencional",
  "sumoDeadlift-string": "Peso Muerto Sumo",
  "romanianDeadlift-string": "Peso Muerto Rumano",
  "singleLegRDL-string": "Peso Muerto a una Pierna",
  "stiffLegRDL-string": "Peso Muerto Piernas Rectas",
  "goodMorning-string": "Buenos Días",
  "hipThrust-string": "Hip Thrust",
  "hyperextensions-string": "Hiperextensiones",
  "gluteHamRaise-string": "Elevación Glúteo-Femoral",
  "abductorMachine-string": "Máquina de Abductor",
  "benchPress-string": "Press Banca",
  "inclineBenchPress-string": "Press Banca Inclinado",
  "declineBenchPress-string": "Press Banca Declinado",
  "machinePress-string": "Press en Máquina",
  "floorPress-string": "Press de Suelo",
  "jmPress-string": "Press JM",
  "inclinePushUp-string": "Flexiones en Banco Inclinado",
  "pushUp-string": "Flexiones",
  "tricepExtensions-string": "Extensiones de Tríceps",
  "tricepPushdown-string": "Empuje de Tríceps",
  "flies-string": "Aperturas",
  "skullCrushers-string": "Skull Crushers",
  "military-string": "Press Militar",
  "dips-string": "Fondos",
  "handstandPushUp-string": "Flexiones en Pino",
  "landminePress-string": "Press Landmine",
  "cableRow-string": "Remo con Polea",
  "tBarRow-string": "Remo en T",
  "chestSupportedRow-string": "Remo en Banco Inclinado",
  "pendlayRow-string": "Remo Pendlay",
  "inclineRow-string": "Remo Inclinado",
  "sealRow-string": "Remo Seal",
  "oneArmRow-string": "Remo a una Mano",
  "row-string": "Remo",
  "facePull-string": "Face Pull",
  "invertedBWRows-string": "Remo Invertido con Peso Corporal",
  "reverseFlies-string": "Pájaros",
  "pullUp-string": "Dominadas",
  "pullDown-string": "Jalón al pecho",
  "pullOver-string": "Pullover",
  "uprightRow-string": "Remo Vertical",
  "curls-string": "Curl de Bíceps",
  "inclineCurls-string": "Curl de Bíceps Inclinado",
  "hammerCurls-string": "Curl de Bíceps Martillo",
  "lateralRaise-string": "Elevación Lateral",
  "frontRaise-string": "Elevación Frontal",
  "abWheel-string": "Rueda Abdominal",
  "copenhagenPlank-string": "Plancha Copenhague",
  "sidePlank-string": "Plancha Lateral",
  "plank-string": "Plancha",
  "crunchAbdominal-string": "Crunch Abdominal",
  "landmineRotation-string": "Rotación con Barra en el Suelo",
  "calfRaise-string": "Elevación de Talones",
  "legLowers-string": "Elevación de Piernas",
  "pallofPress-string": "Press Pallof",
  "run-string": "Correr",
  "cleanPull-string": "Clean Pull",
  "TITOL LLISTA MODIFICADORS": "",
  "Barbell-string": "Barra",
  "Dumbbell-string": "Mancuerna",
  "SafetyBar-string": "Safety Bar",
  "TrapBar-string": "Barra Hexagonal",
  "ZBar-string": "Barra Z",
  "Cable-string": "Polea",
  "Machine-string": "Máquina",
  "SmithMachine-string": "Máquina Smith",
  "Beltless-string": "Sin Cinturón",
  "Tempo-string": "Tempo",
  "TouchAndGo-string": "Touch & Go",
  "1ctPause-string": "Pausa 1ct",
  "2ctPause-string": "Pausa 2ct",
  "3ctPause-string": "Pausa 3ct",
  "5ctPause-string": "Pausa 5ct",
  "300Tempo-string": "Tempo 300",
  "400Tempo-string": "Tempo 400",
  "500Tempo-string": "Tempo 500",
  "600Tempo-string": "Tempo 600",
  "303Tempo-string": "Tempo 303",
  "320Tempo-string": "Tempo 320",
  "530Tempo-string": "Tempo 530",
  "Low2ctPause-string": "Pausa Baja 2ct",
  "Low3ctPause-string": "Pausa Baja 3ct",
  "High2ctPause-string": "Pausa Alta 2ct",
  "High3ctPause-string": "Pausa Alta 3ct",
  "LowPin-string": "Pin Bajo",
  "MiddlePin-string": "Pin Medio",
  "HighPin-string": "Pin Alto",
  "Deficit-string": "Déficit",
  "5cmDeficit-string": "Déficit de 5cm",
  "10cmDeficit-string": "Déficit de 10cm",
  "LowBlock-string": "Bloque Bajo",
  "HighBlock-string": "Bloque Alto",
  "Spoto-string": "Spoto",
  "HalfBoard-string": "Media Tabla",
  "1Board-string": "1 Tabla",
  "2Boards-string": "2 Tablas",
  "3Boards-string": "3 Tablas",
  "4Boards-string": "4 Tablas",
  "5Boards-string": "5 Tablas",
  "Board-string": "Tabla",
  "Standard-string": "Estándar",
  "HighBar-string": "Barra Alta",
  "LowBar-string": "Barra Baja",
  "SnatchGrip-string": "Agarre Snatch",
  "ReverseGrip-string": "Agarre Inverso",
  "Pronated-string": "Pronado",
  "Supinated-string": "Supinado",
  "VeryCloseGrip-string": "Agarre Muy Cerrado",
  "CloseGrip-string": "Agarre Cerrado",
  "WideGrip-string": "Agarre Ancho",
  "VeryWideGrip-string": "Agarre Muy Ancho",
  "NeutralGrip-string": "Agarre Neutro",
  "VeryCloseStance-string": "Posición Muy Cerrada",
  "CloseStance-string": "Posición Cerrada",
  "WideStance-string": "Posición Abierta",
  "VeryWideStance-string": "Posición Muy Abierta",
  "InSplit-string": "In Split",
  "Chains-string": "Cadenas",
  "WeightReleasers-string": "Weight Releasers",
  "Band-string": "Banda",
  "LightBand-string": "Banda Ligera",
  "AverageBand-string": "Banda Media",
  "StrongBand-string": "Banda Fuerte",
  "ReverseLightBand-string": "Banda Ligera Inversa",
  "ReverseAverageBand-string": "Banda Media Inversa",
  "ReverseStrongBand-string": "Banda Fuerte Inversa",
  "ReverseBand-string": "Banda Inversa",
  "Belt-string": "Cinturón",
  "KneeWraps-string": "Vendas",
  "KneeSleeves-string": "Rodilleras",
  "Slingshot-string": "Slingshot",
  "Straps-string": "Straps",
  "Larsen-string": "Larsen",
  "FeetUp-string": "Pies Arriba",
  "Clusters-string": "Clusters",
  "SingleArm-string": "Un Brazo",
  "SingleLeg-string": "Una Pierna",
  "Seated-string": "Sentado",
  "Standing-string": "De Pie",
  "Lying-string": "Acostado",
  "Unilateral-string": "Unilateral",
  "Kodama-string": "Kodama",
  "chats-string": "Chats",
  "messages-string": "Mensajes",
  "messagePlaceholder-string": "Mensaje...",
  "openEmojiPicker-string": "Abrir selector de emojis",
  "closeEmojiPicker-string": "Cerrar selector de emojis",
  "coachReplied-string": "Ha respondido",
  "youReplied-string": "Has respondido",
  "nowMessageCoach-string": "¡Ahora puedes mandar mensajes a tu entrenador!",
  "replyPlaceholder-string": "Responder...",
  "coach-string": "Entrenador",
  "now-string": "Ahora",
  "yesterday-string": "Ayer",
  "photo-string": "Foto",
  "viewVideo-string": "Ver vídeo",
  "video-string": "Vídeo",
  "changeVideo-string": "Cambiar vídeo",
  "deleteVideo-string": "Eliminar vídeo",
  "NoFileFoundTitle-string": "Archivo no encontrado",
  "NoFileFoundText-string": "Es posible que este contenido haya sido eliminado",
  "videoNotAvailableTitle-string": "Vídeo No Disponible",
  "videoNotAvailableText-string": "Este vídeo no está disponible en este momento",
  "videoCodecPlaybackIssueTitle-string": "Ya estamos en ello",
  "videoCodecPlaybackIssueText-string": "Ahora mismo tu navegador no puede reproducir este formato de vídeo. Lo estamos arreglando durante las próximas horas y este vídeo volverá a funcionar muy pronto.",
  "videoStillLoadingText-string": "Este vídeo aún está cargando",
  "imageNotAvailableTitle-string": "Imagen No Disponible",
  "imageNotAvailableText-string": "Esta imagen no está disponible en este momento",
  "downloadComplete-string": "Se ha guardado en la galería",
  "downloadError-string": "Error durante la descarga",
  "sendingVideo-string": "Enviando Vídeo...",
  "sendingVideoInChat-string": "Enviando {{item}} vídeo en el chat...",
  "sendingVideosInChat-string": "Enviando {{item}} vídeos en el chat...",
  "videoTooLong-string": "El vídeo debe durar menos de 2 minutos",
  "addVideo-string": "Enviar",
  "videoAlertTitle-string": "SUBIR VÍDEO",
  "videoAlertText-string": "Tu entrenador no ha solicitado un vídeo para esta serie. ¿Quieres subirlo de todos modos?",
  "waitingToSendMessage-string": "Esperando a enviar mensajes...",
  "permissionsAlertTitle-string": "PERMISOS DE LA WEB",
  "permissionsAlertText-string": "Habilita los permisos a Efort Coach desde la configuración del navegador",
  "emptyChatTitle-string": "Bienvenido a Efort Chat",
  "emptyChatText-string": "Envía mensajes, audios e imágenes, y recibe los vídeos de cada serie",
  "noStorageLeftTitle-string": "ALMACENAMIENTO INSUFICIENTE",
  "noStorageLeftText-string": "El dispositivo no tiene suficiente espacio de almacenamiento y algunas funciones del chat podrían verse afectadas.",
  "videoDeletedSuccessfully-string": "Vídeo Eliminado Correctamente",
  "errorDeletingVideo-string": "Error al Eliminar el Vídeo",
  "errorDeletingVideoOffline-string": "Se Necesita Internet para Borrar el Vídeo",
  "selectChatTitle-string": "Selecciona un Chat",
  "selectChatText-string": "Por favor selecciona un chat para ver los mensajes",
  "markAsUnread-string": "Marcar como no leído"
}
